import { Toast, Modal } from 'antd-mobile';
import lrz from 'lrz';

import { history } from 'src/history';

import { ajax } from '@utils/http';
import { setAppId, getAppId, checkIfLogin } from '@utils/global';
import { docCookies, getUrlQueryStringObj, getUrlSearch, getQueryString, getCurrentPageQueryParams } from '@utils/tools';
import { pageInstance } from '@utils/page';
import { customEvent } from '@utils/customEvent';
import { noDevPageList, showNoDevToast } from '@utils/noDevPageList';
import util from '@utils/util';

import officialPageList from 'src/official-page/officialPageList';
import oldPageList from './oldPageList';

import { PreviewImage } from 'src/common/preview-image/PreviewImage';
import { ChooseLocation } from 'src/common/choose-location/ChooseLocation';
import { OpenLocation } from 'src/common/open-location/OpenLocation';
// import has from '@atomicservice/asweb-sdk';
/**
 * 原app.js的其他模块引用（有替代方案时删除）
 */
// var qiniuUploader = require('./utils/qiniuUploader.js');

/**
 * APP 实例
 */
let appInstance = null;
/**
 *  APP 全局变量
 */
const globalData = {
  /**
   * 当前APPID
   */
  appId: getAppId(),
  historyDataId: '',
  /**
   * 导航路由数组
   */
  tabBarPagePathArr: [],
  homepageRouter: '',
  formData: null,
  userInfo: {},
  systemInfo: null,
  sessionKey: '',
  notBindXcxAppId: false,
  waimaiTotalNum: 0,
  waimaiTotalPrice: 0,
  takeoutLocate:{},
  takeoutRefresh : false,
  communityGroupRefresh: false,
  isLogin: false,
  locationInfo: {
    latitude: '',
    longitude: '',
    address: '',
    info: {}
  },
  getDistributionInfo: '',
  getDistributorInfo: '',
  PromotionUserToken: '',
  communityUserToken: '', //社区团购团长分享token
  previewGoodsOrderGoodsInfo: [],
  goodsAdditionalInfo: {},
  urlLocationId:'',
  turnToPageFlag: false,
  wxParseOldPattern: '_listVesselRichText_',
  cdnUrl: 'http://cdn.jisuapp.cn',
  defaultPhoto: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/default_photo.png',
  siteBaseUrl: location.origin,
  userDomain: location.origin, // 用户子域名
  appTitle: '',
  appDescription: '',
  appLogo: '',
  /**
   * 扫描二维码进入小程序所带参数代理商的user-token
   */
  p_u: '',
  /**
   * 是否有多商家列表组件
   */
  hasFranchiseeList: false,
  /**
   * 是否有多商家连锁组件
   */
  hasFranchiseeChain: false, 
  /**
   * 连锁店ID
   */
  chainAppId: '',
  hasTopicCom: false,
  pageScrollTop: 0,
  topicRefresh: false,
  kbHeight: '',
  goodsStoreConfig: '',
  goodsfranchiseeStoreConfig: {},
  /**
   * 有悬浮窗话题列表地图
   */
  susTopicsMap: {},
  /**
   * 需要刷新的页面
   */
  needRefreshPages: [],
  /**
   * 页面计数数据
   */
  newCountDataOnPage: {},
  /**
   * 子店底部导航信息
   */
  tabbarInfo:{},
  /**
   * 当前页面栈（暂时只有route信息）
   */
  currentPages: [],
  /**
   * webapp专有：app初始化时将页面参数全部保存起来
   */
  queryParams: {},
};
/**
 * 设置当前APP实例
 * @param {object} instance  传入this
 */
const setApp = (instance) => {
  appInstance = instance;
}
/**
 * APP方法
 */
const appMethod = {
  /**
   * 全局数据
   */
  globalData: globalData,
  socket: null,
  onLaunch: function () {
    let userInfo;
    if (userInfo = this.getStorageSync('userInfo')) {
      this.globalData.userInfo = userInfo;
    }
    this.appInitial();
    this.getShareAppSetting();
  },
  appInitial: function () {
    let that = this;
    this._getSystemInfo({
      success: function (res) {
        that.setSystemInfoData(res);
      }
    });
    // TODO webpp应该不需要，暂时注释
    // this.sendRequest({
    //   url: '/index.php?r=AppUser/MarkWxXcxStatus',
    //   data: {
    //     his_id: this.globalData.historyDataId
    //   },
    //   method: 'GET',
    //   header: {
    //     'content-type': 'application/json'
    //   }
    // });
  },
  /**
   * 设置用户账号信息：微信号（登录后使用）
   */
  setQueryParams: function() {
    this.globalData.queryParams = getCurrentPageQueryParams();
  },
  /**
   * 绑定用户账号信息：微信号
   */
  bindUserAccount: function() {
    let params = {...this.globalData.queryParams, ...getCurrentPageQueryParams()};
    if (!(params['account'] && params['from_account'])) {
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppUser/BindWeixinAccount',
      data: {
        account: params['account'],
        from_account: params['from_account']
      }
    })
    this.sendRequest({
      url: '/index.php?r=AppUser/UserCrmWxAccountBind',
      data: {
        account: params['from_account'],
      }
    })
  },
  onShow: function (options) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 页面找不到处理
   */
  onPageNotFound: function () {
    this.turnToPage(this.getHomepageRouter());
  },
  onError: function (error) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  onHide: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  bindUserTokenByPid: function(p_id){
    let that = this;
    that.sendRequest({
      url: '/index.php?r=AppDistribution/GetUserTokenByPId',
      data: {
        p_id: p_id
      },
      success: res => {
        if (res.data && res.data.user_token) {
          that.globalData.communityUserToken = res.data.user_token;  //社区团购分享
          that._getPromotionUserToken({
            user_token: res.data.user_token
          });
        }
      }
    })
  },
  _getPromotionUserToken: function (param) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  returnSubPackageRouter: function (router) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  _getSystemInfo: function (options) {
    this.getSystemInfo({
      success: function (res) {
        typeof options.success === 'function' && options.success(res);
      },
      fail: function (res) {
        typeof options.fail === 'function' && options.fail(res);
      },
      complete: function (res) {
        typeof options.complete === 'function' && options.complete(res);
      }
    })
  },
  /**
   * 发请求 TODO 未完成
   * @param options 传入参数的对象
   */
  sendRequest: function(options) {
    let that = this;
    // 请求参数
    let data = options.data || {};
    if (options.subshop) {
      data.app_id = options.subshop;
      options.chain = false;
    }
    if (options.chain && this.globalData.chainAppId) {
      data.app_id = this.getChainAppId();
    }
    if (!data.app_id) {
      data.app_id = this.getAppId();
    }
    // TODO: 暂时都不设loading
    let hideLoading = typeof options.hideLoading === 'boolean' ? options.hideLoading : true;
    ajax({
      url: options.url,
      data: data,
      type: options.method || 'GET', // TOOD: 确定到底是method还是type
      headers: options.header,
      loading: !hideLoading,
      timeout: options.timeout,
      success: (data, res) => {
        if (res.statusCode && res.statusCode != 200) {
          that.hideToast();
          that.showToast({
            title: '' + res.errMsg,
            icon: 'none'
          });
          typeof options.successStatusAbnormal == 'function' && options.successStatusAbnormal(res.data);
          return;
        }
        if (data.status && data.status != 0) {
          if (data.status == 2 || data.status == 401) {
            that.setIsLogin(false);
            that.goLogin();
            // TODO: 登录成功回调
            return;
          }
          if (data.status == 5) {
            typeof options.successStatus5 == 'function' && options.successStatus5(data);
            return;
          }
          if(data.status == 1){
            options.success && options.success(data);
          }
          if (typeof options.successStatusAbnormal == 'function' && (options.successStatusAbnormal(data) === false)) {
            return;
          }
          that.hideToast();
          if (!options.hideModal) {
            that.showModal({
              content: '' + data.data,
              confirm: function () {
                typeof options.successShowModalConfirm == 'function' && options.successShowModalConfirm(data);
              }
            });
          }
          if (options.hideTemplateLoading) {
            options.hideTemplateLoading();
          }
          return;
        }
        options.success && options.success(data);
      },
      error: (res) => {
        options.fail && options.fail(res);
      },
      complete: (res) => {
        options.complete && options.complete(res)
      }
    });
  },
  /**
   * 跳转页面
   * @param url 要跳转页面的url
   * @param obj 要传入的参数对象
   */
  turnToPage: function(url = '', obj = {}, isRedirect) {
    // console.log('测试', has)
    // has.asWeb.getEnv({
    //   callback: (err, res) => {
    //     // {"brand":"HUAWEI","deviceType":"phone","osFullName":"OpenHarmony-5.0.1.73(Beta2)","productModel":"ALN-AL00"}"  
    //     console.log(err,JSON.stringify(res))
    //   }
    // });
    let urlArr = url.split('?')[0].split('/');
    let router = urlArr[urlArr.length - 1];
    // 兼容处理，防止第二个参数不为对象
    if (typeof obj !== 'object') {
      // 不为对象的第二个参数默认为布尔值，实际为isRedirect
      isRedirect = Boolean(obj) || false;
      obj = {}; // 处理为对象，防止后续报错
    } 
    let state = Object.assign(obj, getUrlQueryStringObj(url));
    let search = getUrlSearch(state);
    
    // 已经在登录页的话，就不再跳转到登录页
    let pathnameArr = location.pathname.split('/');
    if (pathnameArr[pathnameArr.length - 1] === 'loginPage' && router === 'loginPage') {
      return;
    }
    // webapp暂不支持使用插件
    if (router.indexOf('plugin') === 0) {
      Toast.info('插件不支持跳转');
      return;
    }
    // 开发完待测试的页面
    const testingPageList = {
    }
    if (testingPageList[router]) {
      Toast.info(<div><div>当前功能测试中</div><div>即将开放使用</div></div>);
      return;
    }
    let currentPageData = appInstance.state.appData[router];
    if (officialPageList[router] || currentPageData) {
      // 当前官方页面已开发 或 当前为用户自定义页面 或 外链页面

      // 判断是否为外链页面
      if (currentPageData && currentPageData['customFeature']) {
        let pageUrl = currentPageData['customFeature']['pageUrl'];
        if (pageUrl) {
          window.open(pageUrl);
          return;
        }
        // 重定向
        if (isRedirect) {
          history.replace(`/${router}${search}`, state);
          return;
        }
      }
      history.push(`/${router}${search}`, state);
    } else if (oldPageList[router]) {
      // 有旧页面跳回旧页面
      let oldUrl = `/app?_app_id=${getAppId()}&${oldPageList[router](state)}`;
      console.log('oldUrl', oldUrl);
      window.location.href=oldUrl;
    } else {
      // 当前不支持 或 未开发 功能
      if (noDevPageList.hasOwnProperty(router)) {
        showNoDevToast();
        return;
      }
      Toast.info('跳转页面不存在');
    }
  },
  // socket估计还存在一些问题，之后修复
  connectSocket: function(options) {
    const { url, header, method } = options;
    this.socket = new WebSocket(url);
  },
  onSocketOpen: function(cb) {
    this.socket.onopen = (res) => {
      console.warn('socket连接成功')
      cb(res);
    };
  },
  sendSocketMessage: function(options) {
    if (this.socket.readyState == 1) {
      this.socket.send(options);
      console.warn('socket向服务器发送数据', options)
    }
  },
  onSocketMessage: function(cb) {
    if (this.socket.readyState == 1) {
      this.socket.onmessage = function(res) {
        console.warn('socket服务器端返回数据', res)
        cb(res);
      }
    }
  },
  closeSocket: function() {
    this.socket.close();
  },
  onSocketClose: function(cb) {
    let readyState = this.socket.readyState;
    if (readyState === 3) {
      cb();
    }
  },
  onSocketError: function(cb) {
    this.socket.onerror = function() {
      cb();
    }
  },
  chainTurnToPage: function (url) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 小程序：跳转到某个页面，并关闭其余页面栈上的页面
   */
  reLaunch: function (options) {
    this.setPageRouter(options.url);
    this.turnToPage(options.url);
    // wx.reLaunch({
    //   url: options.url,
    //   success: options.success,
    //   fail: options.fail,
    //   complete: options.complete
    // })
  },
  switchToTab: function (url) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  turnBack: function (options = {}) {
    let delta = Number(options.delta) || 1;
    history.go(-delta)
  },
  /**
   * 跳转小程序
   * 这个视乎是可以从web跳转。因为公众号文章可以实现
   * TODO
   */
  navigateToXcx: function () {
    Toast.info('web端不支持跳转到微信小程序');
  },
  /**
   * 模拟微信顶部导航标题设置
   * @param {*} title 
   */
  setNavigationBarTitle: function({title, success, fail, complete}) {
    this.setPageTitle(title);
    complete && complete();
    success && success();
  },
  /**
   * 设置页面上面的标题
   */
  setPageTitle: function (title) {
    document.title = title;
    if(this.isWeixin()){
      let body = document.getElementsByTagName('body')[0];
      let iframe = document.createElement("iframe");
      iframe.setAttribute("src", "/favicon.ico");
      iframe.setAttribute("style", "display:none");
      iframe.addEventListener('load', function() {
        setTimeout(function() {
            try{
              iframe.removeEventListener('load');
            }catch (err){}
            document.body.removeChild(iframe);
        }, 0);
      });
      document.body.appendChild(iframe);
    }
  },
  /**
   * 展示轻提示
   * 注： duration = 0 时，onClose 无效，toast 不会消失；隐藏 toast 需要手动调用 hide
   */
  showToast: function (param = {}) {
    param.duration = param.duration ? param.duration/1000 : 1.5; //单位换算。从毫秒换成秒
    if(param.icon == 'success'){
      Toast.success( param.title, param.duration, param.success || null , param.mask || false);
    }else if(param.icon == 'fail'){
      Toast.fail( param.title, param.duration, param.success || null , param.mask || false);
    }else if(param.icon == 'offline'){
      Toast.offline( param.title, param.duration, param.success || null , param.mask || false);
    }else{
      Toast.info( param.title, param.duration, param.success || null , param.mask || false);
    }
  },
  /**
   * 隐藏轻提示
   */
  hideToast: function () {
    Toast.hide();
  },
  /**
   * 暂时加载loading
   */
  showLoading: function (param = {}) {
    param.duration = param.duration ? param.duration/1000 : 1.5; //单位换算。从毫秒换成秒
    Toast.loading(param.title || '加载中...', param.duration1, param.success || null , param.mask || true);
  },
  /**
   * 隐藏loading
   */
  hideLoading: function () {
    Toast.hide();
  },
  /**
   * 展示模态框
   */
  showModal: function (param = {}) {
    const actions = [{
        text: param.confirmText || '确定',
        onPress: (res) => typeof param.confirm == 'function' && param.confirm(res),
        style: {color: param.confirmColor || '#3CC51F'}
    }];
    if(param.showCancel){
      actions.unshift({
        text: param.cancelText || '取消',
        onPress: (res) => typeof param.cancel == 'function' && param.cancel(res),
        style: {color: param.cancelColor || '#000000'}
      });
    }
    Modal.alert(param.title || '', param.content , actions);
  },
  chooseVideo: function (param, maxDuration, source) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取视频上传token
   * @param file
   * @param callback
   */
  getVideoUpToken: function (file, callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 视频上传成功后的回调
   * @param file
   * @param callback
   */
  uploadSuccessCallback: function (file, callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 根据视频id获取视频链接
   * @param video_id
   * @param callback
   */
  getVideoUrlById: function (video_id, callback) {
    if (!video_id) {
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoLibURL',
      data: {
        id: video_id
      },
      success: function (res) {
        typeof callback === 'function' && callback(res.data);
      },
      error: function (err) {
        console.log(err);
      }
    });
  },
  /**
   * 选择图片接口
   * @param {function} callback 上传成功回调
   */
  chooseImage: function (callback) {
    // TODO 此方法有可能行不通。等找到办法在解决。可以先用img-upload组件
    let that = this;
    let ipt = document.createElement('input');
    ipt.type = "file";
    ipt.style = "width:0;height:0;opacity:0;padding:0;margin:0;border:none;";
    ipt.accept = "image/jpg, image/jpeg, image/gif, image/bmp, image/jp2, image/x-ms-bmp, image/x-png, image/png";
    document.body.appendChild(ipt);
    ipt.onchange = function(e){
      that.showLoading({
        title: '上传中...',
        icon: 'loading',
        duration: 10000
      });
      let file = e.target.files[0];
      if (!file) {
        return;
      }
      const option = {
        width: 750,
        quality: 0.8,
      }
      lrz(file, option).then((result) => {
        ajax({
          url: '/index.php?r=AppData/uploadImg',
          data: {
            img_data: result.base64,
            org: 1
          },
          success: (res) => {
            if (res.status !== 0) {
              Toast.info('图片上传失败，请重试');
              return;
            }
            callback && callback(res.data);
          },
          complete: function(){
            that.hideLoading();
            ipt.remove();
          }
        })
      })
    }
    // ipt.focus();
    ipt.click();
    setTimeout(() => {
      ipt.click();
    }, 100);
  },
  /**
   * 预览图片
   * @param options.current 初始预览的图片URL
   * @param options.urls 非必传 预览图片的URL数组
   */
  previewImage: function (options) {
    if(this.isWeixin()){
      wx.previewImage({
        current: options.current || '',
        urls: options.urls || [options.current]
      })
    }else{
      ReactDOM.render(
        <PreviewImage options={options} />,
        document.getElementById('popup')
      );
    }
  },
  saveImageToPhotosAlbum: function(url){

  },
  playVoice: function (filePath) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  pauseVoice: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  countUserShareApp: function (callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取分享的key ，对应路径上面psid参数
   */
  getShareKey: function () {
    const that = this;
    that.sendRequest({
      url: "/index.php?r=AppShare/GetAppShareKey",
      success: res => {
        if (res.status == 0) {
          that.globalData.pageShareKey = res.data;
        }
      }
    })
  },
  /**
   * 获取管理后台设置的分享图片和标题
   */
  getShareAppSetting: function () {
    const that = this;
    this.sendRequest({
      url: '/index.php?r=AppConfig/GetAppPageShareConfig',
      data: {},
      success: function (res) {
        that.globalData.share_img = res.data.share_img;
        that.globalData.share_title = res.data.share_title;
        that.globalData.appDescription = res.data.description;
      }
    })
  },
  shareClickEvent : function (){
    if(this.isWeixin()){
      let div = document.createElement('div');
      div.style = 'position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.6);z-index:50';
      div.innerHTML = `
      <div><img style="width: 1.2rem;position: absolute;top: .1rem;right: .5rem;" src="https://img.zhichiwangluo.com/zcimgdir/album/file_5d75fa1ace466.png" /></div>
      <div style="color: #fff;font-size: 0.4rem;text-align: center;margin-top: 3rem;">快速分享给好友</div>
      <div style="color: #fff;font-size: .3rem;text-align: center;margin-top: .1rem;line-height: 1rem;">点击屏幕右上角 <span style="display: inline-block;font-size: 0.6rem;vertical-align: top;">·</span><span style="display: inline-block;font-size: 0.8rem;vertical-align: top;">·</span><span style="display: inline-block;font-size: 0.6rem;vertical-align: top;">·</span> 按钮，进行分享</div>
      <div style="text-align: center;margin-top: 0.3rem;">
        <div style="display:inline-block;margin: 0 0.5rem;"><img style="width: 2rem;" src="https://img.zhichiwangluo.com/zcimgdir/album/file_5d75f79c8d589.png" /><span style="display: block;width: .5rem;height: .5rem;margin: .1rem auto;text-align: center;line-height: .5rem;font-size: .28rem;border-radius:50%;background-color: #fff;">1</span></div>
        <div style="display:inline-block;margin: 0 0.5rem;"><img style="width: 2rem;" src="https://img.zhichiwangluo.com/zcimgdir/album/file_5d75f79d4e270.png" /><span style="display: block;width: .5rem;height: .5rem;margin: .1rem auto;text-align: center;line-height: .5rem;font-size: .28rem;border-radius:50%;background-color: #fff;">2</span></div>
      </div>`;
      div.onclick = function(){
        div.remove();
      }
      document.body.appendChild(div);
    }else{
      let pageInstance = this.getAppCurrentPage();
      this.setClipboardData({
        data: pageInstance.shareData.path,
        success: () => {
          this.showToast({title: '网址已经复制，可以粘贴发给别人'});
        }
      })
    }
  },
  /**
   * 分享统一处理方法。
   */
  shareAppMessage: function (options) {
    let that = this,
      image = '',
      title = '',
      pageInstance = this.getAppCurrentPage(),
      pageShareKey = that.globalData.pageShareKey,
      pageShareType = that.globalData.pageShareType,
      path = options.path,
      desc = '';

    if (pageShareKey) {
      if (path.indexOf('?') < 0) {
        path = path + '?psid=' + pageShareKey
      } else {
        path = path + '&psid=' + pageShareKey
      }
    } else {
      path = path
    }

    if (pageShareType == 1) {
      // TODO
      // that.getRecvChance(1);
    }

    if(options.title){
      title = options.title;
    } else if (pageInstance.data.page_config && pageInstance.data.page_config.share) {
      title = pageInstance.data.page_config.share_title;
    } else {
      title = this.globalData.share_title || this.getAppTitle() || '即速应用';
    }

    if (options.imageUrl) {
      image = options.imageUrl;
    } else if (pageInstance.data.page_config && pageInstance.data.page_config.share) {
      image = pageInstance.data.page_config.share_img || '';
    } else if(this.globalData.share_img){
      image = this.globalData.share_img || '';
    } else {
      image = this.globalData.appLogo;
    }

    if (that.globalData.p_id !== undefined) { // 分销分享添加p_id
      path += (~path.indexOf('?') ? '&' : '?');
      path += 'p_id=' + that.globalData.p_id;
    }

    if(options.desc){
      desc = options.desc;
    }

    return {
      title: title,
      path: path,
      imageUrl: image,
      desc: desc
    }
  },
  /**
   * 去支付，弹出选择支付方式
   * @param {string} param.orderId 订单ID，必传
   * @param {string} param.orderType 订单类型, 默认值1。说明： http://confluence.zhichiwangluo.com/pages/viewpage.action?pageId=2884350
   * @param {string} param.franchisee 子店ID
   * @param {function} param.cancel  支付取消之后触发（目前是点击关闭按钮触发）
   * @param {string} param.successUrl  支付成功之后的跳转的链接
   * @param {string} param.failUrl  支付失败之后的跳转的链接
   */
  goPay: function(param){
    appInstance.payRef.current.showPay({
      orderId: param.orderId,
      orderType: param.orderType || 1,
      franchisee: param.franchisee || '',
      successUrl: param.successUrl || '',
      failUrl: param.failUrl || '',
      cancel: param.cancel
    });
  },
  /**
   * 拨打电话
   */
  makePhoneCall: function (number) {
    window.location.href = "tel:" + number;
  },
  /**
   * 获取定位
   */
  getLocation: function (options) {
    if(this.isWeixin()){
      wx.getLocation({
        type: options.type || 'gcj02',
        success: function (res) {
          typeof options.success === 'function' && options.success(res);
          typeof options.complete === 'function' && options.complete(res);
        },
        fail: function (res) {
          typeof options.fail === 'function' && options.fail(res);
          typeof options.complete === 'function' && options.complete(res);
        }
      })
    } else if (navigator.geolocation){
      navigator.geolocation.getCurrentPosition((position) => {
        const res = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }
        typeof options.success === 'function' && options.success(res);
        typeof options.complete === 'function' && options.complete(res);
      }, (res) => {
        typeof options.fail === 'function' && options.fail(res);
        typeof options.complete === 'function' && options.complete(res);
      })
    } else {
      typeof options.fail === 'function' && options.fail(res);
      typeof options.complete === 'function' && options.complete(res);
    }
  },
  /**
   * 选择位置
   * @param {function} options.success 成功的回调
   * @param {function} options.fail 失败回调
   */
  chooseLocation: function (options) {
    ReactDOM.render(
      <ChooseLocation options={options} />,
      document.getElementById('popup')
    );
  },
  /**
   * 查看地图
   * @param {Number} options.latitude 必填 纬度
   * @param {Number} options.longitude 必填 经度
   */
  openLocation: function (options) {
    if(this.isWeixin()){
      wx.openLocation({
        latitude: options.latitude, // 纬度，浮点数，范围为90 ~ -90
        longitude: options.longitude, // 经度，浮点数，范围为180 ~ -180。
        scale: options.scale || 24, // 地图缩放级别,整形值,范围从1~28。默认为最大
        name: options.name || '', // 位置名
        address: options.address || '', // 地址详情说明
        infoUrl: options.infoUrl || '', // 在查看位置界面底部显示的超链接,可点击跳转
        success: function (res) {
          typeof options.success === 'function' && options.success(res);
        },
        fail: function (res) {
          typeof options.fail === 'function' && options.fail(res);
        }
      });
    } else {
      ReactDOM.render(
        <OpenLocation options={options} />,
        document.getElementById('popup')
      );
    }
  },
  /**
   * 获取经纬度。全局变量有存的就取全局变量里的。否则就取定位获取
   */
  getLatLng: function (options) {
    let that = this;
    let locationInfo = that.globalData.locationInfo;
    if (locationInfo.latitude) {
      let latlng = {
        latitude: locationInfo.latitude,
        longitude: locationInfo.longitude
      };
      typeof options.success === 'function' && options.success(latlng);
    } else {
      this.getLocation({
        type: 'gcj02',
        success: function (res) {
          let latitude = res.latitude,
            longitude = res.longitude;
          if (latitude) {
            that.sendRequest({
              hideLoading: true,
              url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
              data: {
                latitude: latitude,
                longitude: longitude
              },
              success: function (res) {
                that.setLocationInfo({
                  latitude: latitude,
                  longitude: longitude,
                  address: res.data.formatted_addresses.recommend,
                  info: res.data
                });
              }
            });
            let latlng = {
              latitude: latitude,
              longitude: longitude
            };
            typeof options.success === 'function' && options.success(latlng);
          } else {
            typeof options.fail === 'function' && options.fail();
          }
        },
        fail: function () {
          typeof options.fail === 'function' && options.fail();
        }
      });
    }
  },
  /**
   * 复制东西到剪贴板
   */
  setClipboardData: function (options) {
    const input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', options.data || '');
    document.body.appendChild(input);
    input.setSelectionRange(0, 9999);
    if (document.execCommand('copy')) {
      input.select();
      document.execCommand('copy');
      typeof options.success === 'function' && options.success();
    }
    document.body.removeChild(input);
  },
  getClipboardData: function (options) {
    // TODO: 这个暂时没有想到解决办法。
  },
  showShareMenu: function (options) {
    // TODO: web应该没有这个方法
  },
  /**
   * 扫描二维码。
   * TODO
   */
  scanCode: function (options) {
    if(this.isWeixin()){
      wx.scanQRCode({
        needResult: options.needResult || 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: options.success,
        fail: options.fail,
        complete: options.complete
      });
    }else{
      // 非微信部分的扫码需要调研一下
      Toast.info('暂不支持扫码功能');
    }
  },
  /**
   * 将页面滚动到指定位置
   */
  pageScrollTo: function (scrollTop) {
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop || 0;
    const $customPage = document.getElementsByClassName('custom-page')[0];
    if ($customPage) {
      document.getElementsByClassName('custom-page')[0].scrollTop =  scrollTop || 0;
    }
  },
  getAuthSetting: function () {
    // TODO: 未处理当前函数，如确定不需要请删除。web应该模拟不了这个接口
  },
  /**
   * 获取本地存储
   * @param {*} options
   */
  getStorage: function(options = {}) {
    let key = this.getAppId() + '_webapp_' + options.key;
    let data = JSON.parse(localStorage.getItem(key));
    options.success && options.success({data})
    options.complete && options.complete({data});
  },
  /**
   * 获取本地存储(同步)
   * 模拟wx.getStorageSync
   * @param {*} options
   */
  getStorageSync: function(curkey) {
    let key = this.getAppId() + '_webapp_' + curkey;
    return JSON.parse(localStorage.getItem(key));
  },
  /**
   * 设置本地存储
   * @param {*} options
   */
  setStorage: function(options) {
    options = options || {};
    let key = this.getAppId() + '_webapp_' + options.key;
    localStorage.setItem(key, JSON.stringify(options.data));
  },
  /**
   * 移除本地存储
   * @param {*} options
   */
  removeStorage: function(options) {
    options = options || {};
    let key = this.getAppId() + '_webapp_' + options.key;
    localStorage.removeItem(key);
    typeof options.success === 'function' && options.success();
  },
  createAnimation: function (params) {
    // 小程序和web端的差异规则
    const REPLACE_RULE = {
      'timingFunction': 'easing'
    };

    // 基本属性 待补充
    const BASIC_ATTR = [
      'top', 'right', 'bottom', 'left',
      'width', 'height', 'opacity'
    ];

    // 构造函数
    function Amt() { };

    // 涉及到链式调用,因此需要单例,用来判断是否已经实例化
    let amtObj = null;

    // 关键帧: 一个对象，代表关键帧的一个集合
    Amt.prototype.keyframes = {};

    // 可选项: 代表动画持续时间的整形数字 (以毫秒为单位), 或者一个包含一个或多个时间属性的对象：
    Amt.prototype.options = {};

    // 创建动画实例时, 添加的可选项
    for (let key in params) {
      params[key] = params[key] === 'step-start' ? 'linear' : params[key];
      Amt.prototype.options[REPLACE_RULE[key] || key] = params[key];
    }

    // 设置一些基础的原型方法
    // 必须传入一个开始的状态和结束的状态 (比如 top: [0, 1rem])
    BASIC_ATTR.forEach((item) => {
      Amt.prototype[item] = function (obj) {
        let { start, end } = obj;
        Amt.prototype.keyframes[item] = [start, end];
        return amtObj;
      }
    });

    // 可选项方法设置
    Amt.prototype.step = function (obj = {}) {
      for (let key in obj) {
        Amt.prototype.options[REPLACE_RULE[key] || key] = obj[key];
      }
      return amtObj;
    }

    Amt.prototype.rotate = function (obj) {
      let { start, end, dom } = obj;
      Amt.prototype.keyframes['transform'] = [`rotate(${start}deg)`, `rotate(${end}deg)`];
      // 旋转之后需要保留当前的旋转结束的位置
      if (dom) {
        setTimeout(() => {
          dom.style.transform = `rotate(${end}deg)`
        }, Amt.prototype.options.duration);
      }
      return amtObj;
    }

    // 如果实例化过就返回这个对象,否则进行实例化操作
    amtObj = amtObj || new Amt();

    return amtObj;
  },
  /**
   * 导入微信地址。只能在微信里面使用。其他地方无法导入
   */
  chooseAddress: function (options) {
    if(this.isWeixin()){
      wx.openAddress({
        success: function (res) {
          typeof options.success === 'function' && options.success(res);
        },
        fail: function(res){
          typeof options.fail === 'function' && options.fail();
        }
      });
    }else{
      Toast.info('除微信里面，其他地方暂时不支持导入');
    }
  },
  downloadFile: function (url, successfn) {
    // TODO: 按理说不需要
  },
  connectWifi: function (option) {
    // TODO: web实现不了
  },
  startWifi: function (option) {
    // TODO: web实现不了
  },
  wifiErrCode: function (code) {
    // TODO: web实现不了
  },
  checkSession: function (callback) {
    // TODO: web不需要
  },
  /**
   * 公众号登录中
   */
  wechatGzhLogining: false,
  /**
   * 抖音登录中
   */
  douyinLogining: false,
  /**
   * 去登陆微信公众号授权完成
   * @param {*} options
   */
  goLogin: function (options = {}) {
    // 如果处于预览页内嵌中，默认已经游客登录（防止用户在当前页设置跳转去登录）
    if (localStorage.getItem('is_preview') == 1 || getQueryString('is_preview')) {
      // 游客登录 去登录（在预览页中嵌套中用此登录）
      return;
    }
    // 微信浏览器内部登录
    if (this.isWeixin()) {
      if (this.wechatGzhLogining) {
        return;
      }
      this.wechatGzhLogining = true;
      let url = encodeURIComponent(window.location.href);
      if (url.indexOf("jisugpt") != -1 || url.indexOf("gptIndex") != -1) {
        window.location.href = `/index.php?r=Weixin/GzhLogin&app_id=${this.getAppId()}&is_chat=1&redirect_url=${url}`
        return;
      }
      window.location.href = `/index.php?r=Weixin/GzhLogin&app_id=${this.getAppId()}&redirect_url=${url}`
      return;
    }
    // 抖音浏览器登录
    if (this.isDouyin()) {
      if (this.douyinLogining) {
        return;
      }
      this.douyinLogining = true;
      let url = encodeURIComponent(window.location.href);
      window.location.href = `/index.php?r=ByteM/WebLogin&app_id=${this.getAppId()}&redirect_url=${url}`
      return;
    }
    if (this.globalData.currentPages.length > 1) {
      // 当前需要登录页非导航页时，且不为第一层页面时，跳转去登录页面可回退到前一层
      this.turnToPage('loginPage', {}, 1);
    } else {
      // 当前需要登录页为导航页时，跳转去登录页面不可回退
      this.turnToPage('loginPage');
    }
    if (options.success) {
      this.getCurrentPage().callbackFun = options.success;
    }
  },
  /**
   * 是否登录
   */
  isLogin: function () {
    return this.getIsLogin();
  },
  /**
   * 请求用户信息
   */
  requestUserInfo: function() {
    return new Promise((resolve) => {
      this.sendRequest({
        url: '/index.php?r=AppData/getUserInfo',
        type: 'get',
        success: (res) => {
          if (!res.data) {
            return;
          }
          this.setUserInfoStorage(res.data);
          setTimeout(() => {
            this.setPageUserInfo();
          }, 0);
          resolve();
          // TODO 补全代码
        }
      })
    })
    
  },
  /**
   * 页面初始化
   * @description 处理页面传入参数
   */
  onPageLoad: function (options = {}) {
    let that = this;
    let pageInstance = this.getAppCurrentPage() || {};
    // 详情页参数
    let detail = options.detail || '';
    // 多商家参数
    let franchisee = options.franchisee;
    // 社区团购参数
    let promotionName = options.promotionName;

    // 分享参数保存在页面上
    pageInstance.sharePageParams = options;
    // 详情页参数处理
    if (detail) {
      pageInstance.dataId = detail;
    }
    // 多商家参数处理
    if (franchisee) {
      pageInstance.franchiseeId = franchisee;
      pageInstance.fmode = e.fmode;
      pageInstance.setData({
        franchiseeInfo: {
          id: e.franchisee,
          mode: e.fmode || ''
        }
      });
    }
    // 社区团购参数处理
    if (promotionName) {
      this.setPageTitle(promotionName);
    }
    // 页面数据设置 Page.data
    pageInstance.setData({
      dataId: detail,
      addShoppingCartShow: false,
      addTostoreShoppingCartShow: false,
      // 微信开放组件兼容性
      canIUseOfficialAccount: that.globalData.canIUseOfficialAccount,
      // 客服来源
      sessionFrom: this.getPageFranchiseeId() || this.globalData.appId
    });
    this.setPageUserInfo();
    // 全局数据设置
    this.globalData.takeoutRefresh = false; // 外卖组件刷新
    this.globalData.tostoreRefresh = false; // 到店组件刷新
    // 设置【技术支持】是否显示
    this.checkTechSupport();
    // 是否需要去绑定手机
    if (that.globalData.isGoBindPhone) {
      // 登录积分获取判断
      that.loginForRewardPoint(that.globalData.loginGetIntegralTime);
      that.globalData.loginGetIntegralTime = '';
      that.globalData.isGoBindPhone = false;
    }
    // 连锁店需要提前获取数据，否则不进行页面数据初始化
    if (this.globalData.chainNotLoading) {
      return;
    }

    // 进行页面数据初始化
    this.pageDataInitial();
    // 特殊页面数据初始化
    if (pageInstance.data.router === 'userCenterComponentPage') {
      this.getAppECStoreConfig((res) => {
        pageInstance.setData({
          storeStyle: res.color_config
        })
      });
    }
  },
  /**
   * 比较用户是否有权限
   */
  toCompareRole: function (callback) {
    let pageInstance = this.getAppCurrentPage();
    let appRoleData = pageInstance.data.customFeature.appRoleData;
    let _userInfo = this.getUserInfo();

    if (!_userInfo.role_name) {
      typeof callback == 'function' && callback(true);
      return;
    }

    if (_userInfo.role_name.length > 0) {
      let hasRole = false;
      _userInfo.role_name.forEach(value => {
        appRoleData.forEach(item => {
          if (value == item.role_name) {
            hasRole = true;
            return;
          }
        })
        if (hasRole) return;
      })
      if (!hasRole) {
        typeof callback == 'function' && callback(true);
      } else {
        typeof callback == 'function' && callback(false);
      }
    } else if (_userInfo.role_name.length === 0) {
      typeof callback == 'function' && callback(true);
    }
  },
  // TODO: 未处理当前函数，如确定不需要请删除
  pullRefreshTime: '',
  onPagePullDownRefresh: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
    // 未在页面上实现当前触发
  },
  setPageScroll: function (pageInstance) {
    // 当前设置的【触发底部刷新】的组件 索引 (只有一个组件可设置)
    let reachBottomComponentIndex = -1;
    // 可设置【触发底部刷新】的组件
    // 组件类型 转换 组件滚动函数名
    const reachBottomMethodName = {
      'bbs': 'bbsScrollFuc',
      'list-vessel': 'pageScrollFunc',
      'goods-list': 'goodsScrollFunc',
      'seckill': 'seckillScrollFunc',
      'video-list': 'videoScrollFunc',
      'news': 'getNewsList',
      'topic': 'getTopListData',
      'franchisee-list': 'franchiseeScrollFunc',
      'exchange-coupon': 'exchangeCouponScrollFunc',
      'dynamic-classify': 'pageScrollFunc',
      'community-group': 'communityGroupScrollFunc',
      'group-buy-list': 'catchMoreGroupList',
      'presell': 'catchMorePresellList',
    };
    for (let i = 0; i < pageInstance.data.eles.length; i++) {
      let ele = pageInstance.data.eles[i];
      // 判断组件是否隐藏
      if (ele && ele.hidden) {
        continue;
      }
      let eleType = ele.type;
      let customFeature = ele.customFeature;
      // 符合条件
      if (reachBottomMethodName[eleType] && ((eleType == 'news' && customFeature.vesselAutoheight === undefined) || (customFeature.vesselAutoheight == 1 && customFeature.loadingMethod == 0) || eleType == 'bbs')) {
        reachBottomComponentIndex = i;
      }
    }
    if (reachBottomComponentIndex === -1) {
      pageInstance.reachBottomFuc = [];
      return;
    }
    let componentData = pageInstance.data.eles[reachBottomComponentIndex];
    let componentType = componentData.type;
    let reachBottomObj = {
      param: {
        compIndex: reachBottomComponentIndex
      }
    };
    // 【动态列表】/【动态分类】 调取当前页面滚动函数
    if (componentType === 'list-vessel' || componentType === 'dynamic-classify') {
      reachBottomObj['triggerFuc'] = (param) => {
        this.pageScrollFunc(param.compIndex)
      }
    } else {
      reachBottomObj['triggerFuc'] = (param) => {
        pageInstance.callComponentMethod({
          componentIndex: reachBottomComponentIndex,
          methodName: reachBottomMethodName[componentType],
          argvs: [param.compIndex]
        });
      }
    }
    // 当前规则仅一个触底刷新组件
    pageInstance.reachBottomFuc = [reachBottomObj];
  },
  /**
   * 页面数据初始化
   * @param {*} isPullRefresh 
   * @param {*} pageIn 
   * @param {*} isAllowLoad 
   */
  pageDataInitial: function (isPullRefresh, pageIn, isAllowLoad) {
    let _this = this;
    let pageInstance = pageIn || this.getAppCurrentPage();
    let pageRequestNum = pageInstance.requestNum;
    
    pageInstance.downcountObject = {};

    let appRole = Number(pageInstance.data.customFeature.AppRole);
    if (appRole && !isAllowLoad) {
      if (!pageInstance.isCompareRole) {
        pageInstance.isCompareRole = true;
        if (this.isLogin()) {
          _this.toCompareRole(function (value) {
            if (value) {
              _this.showModal({
                content: "您暂时没有浏览该页面的权限，请联系小程序管理员开通。",
                confirm: function (res) {
                  pageInstance.isCompareRole = false;
                  _this.turnBack();
                }
              })
            } else {
              pageInstance.isCompareRole = false;
              _this.pageDataInitial(isPullRefresh, pageIn, true);
            }
          })
        } else {
          this.goLogin({
            success: function () {
              _this.toCompareRole(function (value) {
                if (value) {
                  _this.showModal({
                    content: "您暂时没有浏览该页面的权限，请联系小程序管理员开通。",
                    confirm: function (res) {
                      pageInstance.isCompareRole = false;
                      _this.turnBack();
                    }
                  })
                } else {
                  pageInstance.isCompareRole = false;
                  _this.pageDataInitial(isPullRefresh, pageIn, true);
                }
              })
            }
          });
        }
      }
      return;
    }

    if (!isPullRefresh) {
      _this.setPageScroll(pageInstance);
    }

    // 优先判断页面是否绑定了数据对象，没有绑定时直接展示页面，绑定时就等数据请求之后再展示
    if (!!pageInstance.dataId && !!pageInstance.data.customFeature.form) {
      let dataid = parseInt(pageInstance.dataId);
      let param = {};

      param.data_id = dataid;
      param.form = pageInstance.data.customFeature.form;

      pageInstance.requestNum = pageRequestNum + 1;
      _this.sendRequest({
        hideLoading: pageRequestNum++ == 1 ? false : true,
        url: '/index.php?r=AppData/getFormData',
        data: param,
        method: 'post',
        chain: true,
        success: function (res) {
          let newdata = {};
          let formdata = res.data[0].form_data;

          for (let i in formdata) {
            if (i == 'category') {
              continue;
            }
            if (/region/.test(i)) {
              continue;
            }
            // TODO：小程序处理富文本字段 代码位置
          }
          newdata['detailData'] = formdata;
          pageInstance.setData(newdata);

          // 当有视频字段时，请求视频链接，并放到数据里 (数组)
          let field = _this.getFormPageField(pageInstance.data);
          for (let i in formdata) {
            if (field.indexOf(i) > -1 && formdata[i] instanceof Object && formdata[i].type === 'video') {
              let video = formdata[i];

              pageInstance.requestNum = pageRequestNum + 1;
              _this.sendRequest({
                hideLoading: pageRequestNum++ == 1 ? false : true,   // 页面第一个请求才展示loading
                url: '/index.php?r=AppVideo/GetVideoLibUrl',
                data: {
                  id: video.id
                },
                chain: true,
                method: 'get',
                success: function (res) {
                  let videoUrl = res.data,
                    newdata = {};

                  newdata['detailData.' + i + '.videoUrl'] = videoUrl;
                  pageInstance.setData(newdata);
                }
              });
            }
          }

          // TODO: 处理轮播组件(轮播组)旧数据处理方式 代码区域

          // 进行【动态容器】组件的数据初始化
          pageInstance.data.eles.forEach((ele, eleIndex) => {
            if (ele.type === 'dynamic-vessel') {
              pageInstance.callComponentMethod({
                componentIndex: eleIndex,
                methodName: 'detailPageInit',
                argvs: [eleIndex, pageInstance, formdata]
              });
            }
          })
        },
        complete: function () {
          // TODO
          pageInstance.setData({
            page_hidden: false
          });
        }
      })
    } else if (!pageInstance.dataId && !!pageInstance.data.customFeature.form) {
      // WEBAPP
      // 绑定详情页，但没有具体id
      _this.showModal({
        content: "数据id为空，页面绑定详情页，需要从列表页跳转",
      })
    } else {
      // TODO
      pageInstance.setData({
        page_hidden: false
      });
    }
    // TODO: 当前位置为小程序组件初始化代码位置
    // 进行当前页组件及组件内部子组件的初始化(web端都是重新加载，组件自行初始化)
  },
  onPageScroll: function (e) {
    let pageInstance = this.getAppCurrentPage();
    let pageRouter = pageInstance.page_router;
    this.globalData.susTopicCompindexs = this.globalData.susTopicsMap[pageRouter];
    if (this.globalData.susTopicCompindexs && this.globalData.susTopicCompindexs.length) { // 有悬浮窗话题列表判断是否要显示向上按钮
      let topBtnShow = e.scrollTop > 0 && (this.globalData.pageScrollTop - e.scrollTop > 0);
      for (let i in (this.globalData.susTopicCompindexs)) {
        let compindex = this.globalData.susTopicCompindexs[i];
        if ((pageInstance.data.eles[compindex].topicSuspension.topBtnShow || false) !== topBtnShow) {
          pageInstance.setData({ ['eles[' + compindex + '].topicSuspension.topBtnShow']: topBtnShow });
        }
      }
    }
    this.globalData.pageScrollTop = e.scrollTop;
  },
  getIntegralLog: function (addTime) {
    // TODO: 到时候看分享情况在决定要不要这个
  },
  /**
   * 文章计数
   */
  CountSpreadCount: function (articleId) {
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/CountSpreadCount',
      data: { article_id: articleId },
      success: function (res) { }
    })
  },
  /**
   * 处理虚拟价格
   */
  formVirtualPrice: function (formdata) {
    let modelVP = [];
    let price = '';
    for (let l in formdata.goods_model) {
      modelVP.push(formdata.goods_model[l].virtual_price == '' ? 0 : Number(formdata.goods_model[l].virtual_price))
    }
    if (Math.min(...modelVP) == Math.max(...modelVP)) {
      if (formdata.virtual_price instanceof Object) {
        price = formdata.virtual_price;
        price = Math.min(...modelVP).toFixed(2);
      } else {
        price = Math.min(...modelVP).toFixed(2);
      }
    } else {
      if (formdata.virtual_price instanceof Object) {
        price = formdata.virtual_price;
        price = Math.min(...modelVP).toFixed(2) + '~' + Math.max(...modelVP).toFixed(2);
      } else {
        price = Math.min(...modelVP).toFixed(2) + '~' + Math.max(...modelVP).toFixed(2);
      }
    }
    return price;
  },
  /**
   * 获取动态列表绑定了什么字段
   */
  getListVessel: function (comp) {
    let that = this;
    let field = [];

    if (Object.prototype.toString.call(comp.content) == "[object Array]") {
      for (let i = 0; i < comp.content.length; i++) {
        let cp = comp.content[i];
        if (typeof cp.content == 'object') {
          let f = that.getListVessel(cp);
          field = field.concat(f);
        } else if (cp.customFeature && cp.customFeature.segment) {
          field.push(cp.customFeature.segment);
          if (cp.customFeature.segment == 'default_map') {
            field = field.concat(['region_lng', 'region_lat', 'region_string', 'region_detail']);
          }
        }
      }
    } else {
      for (let i in comp.content) {
        let cp = comp.content[i];
        for (let j = 0; j < cp.length; j++) {
          let cpj = cp[j];
          if (typeof cpj.content == 'object') {
            let f = that.getListVessel(cpj);
            field = field.concat(f);
          } else if (cpj.customFeature && cpj.customFeature.segment) {
            field.push(cpj.customFeature.segment);
            if (cpj.customFeature.segment == 'default_map') {
              field = field.concat(['region_lng', 'region_lat', 'region_string', 'region_detail']);
            }
          }
        }
      }
    }
    return field;
  },
  /**
   * 获取表单绑定了什么字段
   */
  getFormPageField: function (data) {
    let that = this;
    let field = [];
    for (let ele of data.eles) {
      if (typeof ele.content == 'object') {
        let f = that.getListVessel(ele);
        field = field.concat(f);
      } else if (ele.customFeature && ele.customFeature.segment) {
        field.push(ele.customFeature.segment);
        if (ele.customFeature.segment == 'default_map') {
          field = field.concat(['region_lng', 'region_lat', 'region_string', 'region_detail']);
        }
      }
    }
    return field;
  },
  /**
   * 根据组件的ID，返回组件的索引值
   */
  getElementById: function (id, pageInstance) {
    pageInstance = pageInstance || this.getAppCurrentPage();
    let pageData = pageInstance.data.eles;
    let compid = '';
    for (let i in pageData) {
      let ele = pageData[i];
      // if (Object.prototype.toString.call(ele) === "[object Object]"){ //web 这边不需要判断
        if (ele.type && ele.customFeature.id == id && !ele.hidden){
          compid = {
            index: i,
            data: ele
          };
          break;
        }
      // }
    }
    return compid;
  },
  /**
   * 根据组件的ID，返回组件的索引值(替换getElementById)
   */
  findComponentIndexById: function (id, pageInstance) {
    pageInstance = pageInstance || this.getAppCurrentPage();
    let pageData = pageInstance.data.eles || [];
    return pageData.findIndex((ele) => ele.type && ele.customFeature.id == id && !ele.hidden);
  },
  /**
   * 返回关联的组件的索引
   * @param {string} id 被关联的组件的ID，例如 商品列表的ID
   * @param {string} type 关联组件的type, 例如 分类组件的type
   * @param {string} field 关联组件的关联字段，不同的组件会不一样
   * @param {object} pageInstance 页面的实例，不传则获取当前页面
   */
  getInvolvedFromRefreshObject: function (id, type, field, pageInstance) {
    pageInstance = pageInstance || this.getAppCurrentPage();
    let pageData = pageInstance.data.eles;
    let compid = '';
    field = field || "refresh_object";
    for (let i in pageData) {
      let ele = pageData[i];
      // if (Object.prototype.toString.call(ele) === "[object Object]"){
        if (ele.type && type == ele.type && ele.customFeature[field] == id && !ele.hidden){
          compid = {
            index: i,
            data: ele
          };
          break;
        }
      // }
    }
    return compid;
  },
  /**
   * 根据对象的路径去获取对应的值
   */
  getObjectByPath: function (path, obj) {
    path = path.replace(/\[(\w+)\]/g, '.$1');
    let keyArr = path.split('.');
    for(let i = 0; i < keyArr.length; i++){
      let key = keyArr[i];
      if(!obj.hasOwnProperty(key)){
        break;
      }
      obj = obj[key];
    }
    return obj;
  },
  /**
   * 触发点击事件
   * @param {*} e
   */
  tapEventCommonHandler: function (e) {
    let customFeature = JSON.parse(e.currentTarget.dataset.eventParams);
    let compindex = e.currentTarget.dataset.compindex;
    if (!customFeature.compindex && compindex) {
      customFeature.compindex = compindex;
    }
    customEvent({
      customFeature,
      event,
    })
  },
  /**
   * 根据经纬度获取地址
   */
  getAddressByLatLng: function (params, callback) {
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=Map/getAreaInfoByLatAndLng',
      data: {
        latitude: params.lat,
        longitude: params.lng
      },
      success: function (res) {
        callback(res)
      }
    });
  },
  /**
   * 用户制作的页面的分享
   */
  onPageShareAppMessage: function (event) {
    let pageInstance = this.getAppCurrentPage();
    let pagePath = pageInstance.route;
    let image = event.target ? event.target.dataset.image : '';
    let title = event.target ? event.target.dataset.desc : '';
    let desc = this.globalData.appDescription;

    pagePath = window.location.origin + '/zc_webapp/' + pagePath;

    pageInstance.setData({
      pageQRCodeData: {
        shareDialogShow: "100%",
        shareMenuShow: false,
      }
    })

    let pageParam = {
      "detail": pageInstance.dataId,
      "user_token": this.globalData.PromotionUserToken,
      "vcard_user_id": this.globalData.HasCardToShareUserId,
      "franchisee": pageInstance.franchiseeId
    };
    for (let i in pageParam) {
      if (pageParam[i]) {
        if (pagePath.indexOf('?') < 0) {
          pagePath += '?';
        } else {
          pagePath += '&';
        }
        pagePath += i + '=' + pageParam[i];
      }
    }

    return this.shareAppMessage({ path: pagePath, imageUrl: image, title: title, desc: desc });
  },
  onPageShow: function () {
    // this.setPageUserInfo();
    // TODO: 未处理当前函数，如确定不需要请删除
    // let that = this;
    // let pageInstance = this.getAppCurrentPage();
    // let needRefreshPages = this.globalData.needRefreshPages;
    // let pageRouter = this.getPageRouter();
    // let pageIndex = needRefreshPages.indexOf(pageRouter);

    // if (this.globalData.takeoutRefresh) {
    //   this.pageDataInitial();
    //   this.globalData.takeoutRefresh = false;
    // } else if (this.globalData.tostoreRefresh) {
    //   this.pageDataInitial();
    //   this.globalData.tostoreRefresh = false;
    // } else if (this.globalData.topicRefresh && this.globalData.hasTopicCom) {
    //   this.pageDataInitial();
    //   this.globalData.topicRefresh = false;
    // } else if (this.globalData.listVesselRefresh && pageIndex > -1) {
    //   this.pageDataInitial();
    //   needRefreshPages.splice(pageIndex, 1);
    //   if (!needRefreshPages.length) {
    //     this.globalData.listVesselRefresh = false;
    //   }
    // } else if (this.globalData.communityGroupRefresh) {
    //   this.pageDataInitial();
    //   this.globalData.communityGroupRefresh = false;
    // } else {
    //   that.setPageUserInfo();
    // }
    // if (this.globalData.topicTurnToDetail) {
    //   this.globalData.topicTurnToDetail = false;
    // }
    // if (pageInstance.user_center_compids_params.length) {
    //   for (let i in pageInstance.user_center_compids_params) {
    //     let compid = pageInstance.user_center_compids_params[i].compid
    //     this._initUserCenterData(pageInstance, compid);
    //   }
    // }
    // if (!!pageInstance.exchangeCouponComps.length) {
    //   let _this = that
    //   for (let i in pageInstance.exchangeCouponComps) {
    //     let compid = pageInstance.exchangeCouponComps[i].compid;
    //     customComponent["exchange-coupon"].init(compid, pageInstance);
    //   }
    // }
    // 当前页面需要登录且没有绑定手机且未登录
    // if (pageInstance.need_login && !pageInstance.bind_phone && !this.isLogin()) {
    //   this.goLogin({});
    // } else if (pageInstance.need_login && pageInstance.bind_phone && !this.getUserInfo().phone && !that.globalData.isOpenSettingBack) {
    //   if (this.isLogin()) {
    //     setTimeout(function () {
    //       let url = 'pages/' + pageInstance.page_router + '/' + pageInstance.page_router + '?' + util.getCurrentPageArgs();
    //       that.turnToPage('/default/pages/bindCellphone/bindCellphone?p=' + encodeURIComponent(url), 1);
    //     }, 1000);
    //   } else {
    //     let addTime = Date.now();
    //     that.globalData.loginGetIntegralTime = addTime;
    //     that.globalData.isGoBindPhone = true;
    //     this.goLogin({
    //       success: function () {
    //         let userInfo = that.getUserInfo();
    //         if (!userInfo.phone) {
    //           let url = 'pages/' + pageInstance.page_router + '/' + pageInstance.page_router + '?' + util.getCurrentPageArgs();
    //           that.turnToPage('/default/pages/bindCellphone/bindCellphone?p=' + encodeURIComponent(url), 1);
    //         } else {
    //           that.loginForRewardPoint(addTime);
    //           that.globalData.isGoBindPhone = false;
    //         }
    //       }
    //     });
    //   }
    //   that.globalData.isOpenSettingBack = false;
    // }
    // 返回排号组件重新刷新
    // if (pageInstance.rowNumComps.length) {
    // }
    // 返回到店组件重新刷新
    // if (pageInstance.tostoreComps.length && pageInstance.returnToVersionFlag === 1) {

    // }
    // 多商家列表待审核状态进入预览修改了模板返回需要重新加载
    // if (this.globalData['franchiseeTplChange-' + pageInstance.page_router]) {

    // }
    // 签到刷新累积签到详情
    // if (pageInstance.signInComps.length) {
    // }
    // 多商家列表重新定位后刷新组件
    // if (this.globalData.franchiseeListCompsRefresh) {

    // }
    // 返回竖版列表重新刷新
    // if (pageInstance.verticalListComps && pageInstance.verticalListComps.length) {

    // }

    // let pageData = pageInstance.data;
    // for (let i in pageData) {
    //   let ele = pageData[i];
    //   if (Object.prototype.toString.call(ele) === "[object Object]"){
    //       let type = ele.type;
    //     if (type && !ele.hidden){
    //       let compid = ele.compId;
    //       customComponent[type] && customComponent[type].onPageShow && customComponent[type].onPageShow(compid, pageInstance);
    //     }
    //   }
    // }
  },
  onPageHide: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  returnListHeight: function (isshow, takeout, mode) {
    return this.getSystemInfoSync().windowHeight;
  },
  onPageReachBottom: function (reachBottomFuc = []) {
    reachBottomFuc.forEach((e) => {
      e.triggerFuc(e.param);
    })
  },
  onPageUnload: function (page) {
    let pageInstance = page || this.getAppCurrentPage();
    let pageRouter = page ? page.page_router : pageInstance.page_router;
    this._logining = false;
    let downcountArr = pageInstance.downcountArr;
    if (downcountArr && downcountArr.length) {
      for (let i = 0; i < downcountArr.length; i++) {
        downcountArr[i] && downcountArr[i].clear();
      }
    }

    if (this.globalData.newCountDataOnPage[pageRouter]) { // 清除绑定页面上的计数
      delete this.globalData.newCountDataOnPage[pageRouter];
    }
    //清除定时器
    let dco = pageInstance.downcountObject;
    for (let key in dco) {
      let dcok = dco[key]
      if (dcok && dcok.length) {
        for (let i = 0; i < dcok.length; i++) {
          dcok[i] && dcok[i].clear();
        }
      }
    }
    //清除多人点餐定时器
    pageInstance.data.eles.forEach((ele) => {
      if (ele.type === 'vertical-list') {
        if (ele.timer) {
          clearInterval(ele.timer);
        }
      }
    })

    //清除动态分类借节点监控
    pageInstance.data.eles.forEach((ele, eleIndex) => {
      if (ele.type === 'dynamic-classify') {
        if (ele.classify_observer) {
          clearInterval(ele.classify_observer);
        }
        if (ele.list_observer) {
          clearInterval(ele.list_observer);
        }
      }
    })
  },
  /**
   * 触发预览大图
   * @param {*} event
   */
  tapPrevewPictureHandler: function (event) {
    let img = event.currentTarget.dataset.img;
    let imgarr = event.currentTarget.dataset.imgarr.split(',');
    this.previewImage({
      current: event.currentTarget.dataset.img || imgarr[0],
      urls: imgarr instanceof Array ? imgarr : [imgarr],
    })
  },
  pageScrollFunc: function (event) {
    // TODO: 未完全实现
    let pageInstance = this.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];

    if (!compData) {
      console.log('pageScrollFunc is not find compData');
      return;
    }
    if (compData.is_search) {
      let searchComponentIndex = compData.searchEle;
      pageInstance.callComponentMethod({
        componentIndex: searchComponentIndex,
        methodName: 'searchList',
        argvs: [searchComponentIndex, event]
      });
    } else {
      this._pageScrollFunc(event);
    }
  },
  _pageScrollFunc: function (event) {
    let pageInstance = this.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    let curpage = (compData.curpage || 0) + 1;
    let newdata = {};
    let param = {};
    let _this = this;
    let customFeature = compData.customFeature;
    let url = '/index.php?r=AppData/getFormDataList';

    if (compData.type === 'news') {
      if (compData.pageObj.noMore && typeof event == 'object' && event.type == 'tap') {
        _this.showModal({
          content: '已经加载到最后了'
        });
        return;
      }
      pageInstance.callComponentMethod({
        componentIndex: compindex,
        methodName: 'getNewsList',
        argvs: [{
          compindex: compindex,
          pageInstance: pageInstance,
        }]
      });
      return;
    }

    if (!compData.is_more && typeof event == 'object' && event.type == 'tap') {
      _this.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    // 动态列表处理
    if (compData.type === 'list-vessel') {
      param = pageInstance.data.eles[compindex].param;
    }
    param.form = customFeature.form;
    param.need_column_arr = compData.need_column_arr;

    // 动态分类组件处理
    if (compData.type === 'dynamic-classify') {
      let len = compData.currentCategory.length;
      let cate = compData.currentCategory[len - 1];
      if (len == 2) {
        let firstCate = compData.currentCategory[0];
        for (let j = 0; j < compData.classifyData.length; j++) {
          let classify = compData.classifyData[j];
          if (classify.category_id == firstCate && classify.subclass.length == 0) {
            cate = firstCate;
            break;
          }
        }
      }
      param = {
        form: compData.classifyGroupForm,
        page_size: compData.customFeature.loadingNum || 15,
        idx_arr: {
          idx: 'category',
          idx_value: cate
        },
        sort_key: compData.sort_key === undefined ? '' : compData.sort_key,
        sort_direction: compData.sort_direction === undefined ? '' : compData.sort_direction
      }
    }
    if (customFeature.form == 'group_buy') {
      url = "/index.php?r=AppGroupBuy/GetGroupBuyGoodsList";
      param.current_status = 0;
    }

    if (customFeature.source && customFeature.source !== 'none') {
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      }
    }

    param.page_size = customFeature.loadingNum || 10;
    param.page = curpage;

    this.sendRequest({
      url: url,
      data: param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        newdata = {};
        let len = compData.list_data ? compData.list_data.length : 0;

        for (let j in res.data) {
          if (customFeature.form == 'group_buy') {
            res.data[j] = {
              form_data: Object.assign({}, res.data[j])
            }
          }
          for (let k in res.data[j].form_data) {
            if (k == 'category') {
              continue;
            }
            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[j].form_data.virtual_price = _this.formVirtualPrice(res.data[j].form_data);
            }
            if (k == 'distance') {
              res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
            }

            let description = res.data[j].form_data[k];

            if (compData.listField && compData.listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
              res.data[j].form_data[k] = '';
            }
          }

          newdata['eles[' + compindex + '].list_data[' + (+j + len) + ']'] = res.data[j];
        }

        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function () {

      }
    })
  },
  franchiseeScrollFunc: function (event) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 点赞 取消点赞
   */
  changeCountRequert: {},
  changeCount: function (event) {
    let dataset = event.currentTarget.dataset;
    let that = this;
    let pageInstance = this.getAppCurrentPage();
    let newdata = {};
    let counted = dataset.counted;
    let compindex = dataset.compindex;
    let objrel = dataset.objrel;
    let form = dataset.form;
    let dataIndex = dataset.index;
    let parentcompindex = dataset.parentcompindex || -1;
    let parentcompData = parentcompindex > -1 ? pageInstance.data.eles[parentcompindex] : null;
    let parentType = dataset.parenttype;
    let url;
    let objIndex = compindex + '_' + objrel;

    if (counted == 1) {
      url = '/index.php?r=AppData/delCount';
    } else {
      url = '/index.php?r=AppData/addCount';
    }

    if (that.changeCountRequert[objIndex]) {
      return;
    }
    that.changeCountRequert[objIndex] = true;

    that.sendRequest({
      url: url,
      data: { obj_rel: objrel },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        newdata = {};

        if (parentcompindex > -1) {
          if (parentcompData.type === 'list-vessel') {
            newdata['eles[' + parentcompindex + '].list_data[' + dataIndex + '].count_num'] = counted == 1
              ? parseInt(pageInstance.data.eles[parentcompindex].list_data[dataIndex].count_num) - 1
              : parseInt(res.data.count_num);
            newdata['eles[' + parentcompindex + '].list_data[' + dataIndex + '].has_count'] = counted == 1
              ? 0 : parseInt(res.data.has_count);
          } else if (parentcompData.type === 'bbs') {
            newdata['eles[' + parentcompindex + '].content.data[' + dataIndex + '].count_num'] = counted == 1
              ? parseInt(pageInstance.data.eles[parentcompindex].content.data[dataIndex].count_num) - 1
              : parseInt(res.data.count_num);
            newdata['eles[' + parentcompindex + '].content.data[' + dataIndex + '].has_count'] = counted == 1
              ? 0 : parseInt(res.data.has_count);
          } else if (parentcompData.type === 'free-vessel' || parentcompData.type === 'popup-window' || parentcompData.type === 'dynamic-vessel') {
            // TODO 跟小程序稍有不同
            path = 'eles[' + parentcompindex + '].content[' + compindex + ']';
            newdata[path + '.count_data.count_num'] = parseInt(res.data.count_num);
            newdata[path + '.count_data.has_count'] = parseInt(res.data.has_count);
          } else if (parentType && parentType.indexOf('list_vessel') === 0) {
            newdata[parentType + '.list_data[' + dataIndex + '].count_num'] = parseInt(res.data.count_num);
            newdata[parentType + '.list_data[' + dataIndex + '].has_count'] = parseInt(res.data.has_count);
          }
        } else {
          newdata['eles[' + compindex + '.count_data.count_num'] = parseInt(res.data.count_num);
          newdata['eles[' + compindex + '.count_data.has_count'] = parseInt(res.data.has_count);
          pageInstance.setData(newdata);
        }

        pageInstance.setData(newdata);
        that.changeCountRequert[objIndex] = false;
      },
      complete: function () {
        that.changeCountRequert[objIndex] = false;
      }
    });
  },
  tapMapDetail: function (event) {
    let dataset = event.currentTarget.dataset;
    let params = dataset.eventParams;
    if (!params) return;

    params = JSON.parse(params)[0];
    this.openLocation({
      latitude: +params.latitude,
      longitude: +params.longitude,
      name: params.desc || '',
      address: params.name || ''
    });
  },
  /**
   * 动态列表/动态分类 跳转页面函数
   * @param {*} event 
   */
  listVesselTurnToPage: function (event) {
    let that = this;
    let dataset = event.currentTarget.dataset;
    let pageInstance = this.getAppCurrentPage();
    let data_id = dataset.dataid;
    let router = dataset.router;
    let isseckill = dataset.isseckill; // 是否是商品秒杀
    let compindex = dataset.compindex;
    let index = dataset.index;
    let compData = pageInstance.data.eles[compindex];
    let list = compData.list_data[index];
    let form_data = list.form_data || list;

    if (this.isTurnToListVesselDetail) { // 防止重复点击
      this.showToast({
        title: '正在跳转，请勿重复点击',
        icon: 'none'
      })
      return;
    }
    this.isTurnToListVesselDetail = true;

    if (compData.haveViewCountEle) { // 动态列表有添加浏览计数
      let objId = compData.form;
      let contentPath =  'eles[' + compindex + '].list_data[' + index + '].count_info.view_info';
      let param = {
        count_type: 2,
        support_cancel: 0,
        effect: 2,
        total_times: 1,
        obj_id: objId,
        data_id: data_id
      }
      // // 计数器组件索引（TODO: 还没找到，要写）
      // let countComponentIndex = -1;
      // // 调用计数器组件的方法
      // pageInstance.callComponentMethod({
      //   componentIndex: countComponentIndex,
      //   methodName: 'newCountAddCount',
      //   argvs: [param, function(res) {
      //     // 调用计数器组件的方法
      //     pageInstance.callComponentMethod({
      //       componentIndex: countComponentIndex,
      //       methodName: 'newCountSetNewData',
      //       argvs: [pageInstance, contentPath, res, function () {
      //         that.isTurnToListVesselDetail = false;
      //         that.globalData.listVesselHaveViewCountEle = true;
      //         that.listVesselTurnToPageAct(router, form_data, data_id, isseckill);
      //       }]
      //     });
      //   }]
      // });
      return;
    }

    this.isTurnToListVesselDetail = false;
    this.listVesselTurnToPageAct(router, form_data, data_id, isseckill);
  },
  /**
   * 动态列表/动态分类 跳转页面后续处理
   * @param {*} router 
   * @param {*} form_data 
   * @param {*} data_id 
   * @param {*} isseckill 
   */
  listVesselTurnToPageAct: function (router, form_data, data_id, isseckill) {
    if (router == '' || router == -1 || router == '-1') {
      return;
    }
    let franchisee = this.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (router == 'tostoreDetail') {
      this.turnToPage('toStoreDetail?detail=' + data_id + chainParam);
    } else if (router == 'goodsDetail') {
      if (isseckill == 1) {
        let seckillType = form_data.is_seckill_activity ? form_data.is_seckill_activity : '';
        let seckill_activity_id = form_data.seckill_activity_id ? form_data.seckill_activity_id : '';
        let seckill_activity_time_id = form_data.seckill_activity_time_id ? form_data.seckill_activity_time_id : '';
        this.turnToPage('seckillDetail?id=' + data_id + '&sec_act_id=' + seckill_activity_id + '&sec_t_id=' + seckill_activity_time_id + '&secType=' + seckillType);
      } else if (form_data.is_group_buy && form_data.is_group_buy == 1) {
        data_id = form_data.goods_id; //模板上不存在goodsId，需要通过页面数据获取
        let group_activity_id = form_data.activity_id || '';
        this.turnToPage('gpgoodsDetail?goods_id=' + data_id + '&activity_id=' + group_activity_id + chainParam);
      } else {
        this.turnToPage('goodsDetail?detail=' + data_id + chainParam);
      }
    } else if (router == 'videoDetail') {
      this.turnToPage('videoDetail?detail=' + data_id + chainParam);
    } else if (router == 'groupGoodsDetail') {
      data_id = form_data.goods_id;//模板上不存在goodsId，需要通过页面数据获取
      let group_activity_id = form_data.activity_id || '';
      this.turnToPage('gpgoodsDetail?goods_id=' + data_id + '&activity_id=' + group_activity_id + chainParam);
    } else if (router == 'franchiseeDetail') {
      let mode = form_data.mode_id;
      this.goToFranchisee(mode, {
        detail: data_id
      });
    } else if (router == 'presellDetail') {
      this.turnToPage(router + '?detail=' + data_id)
    } else{
      this.turnToPage(router + '?detail=' + data_id);
    }
  },
  userCenterTurnToPage: function (event) {
    // 判断是否登录
    let that = this;
    if (this.isLogin()) {
      const {
        router,
        openVerifyPhone,
        eventParams,
        goodsType,
        needCollectInfo,
        index,
      } = event.currentTarget.dataset;
      let param = JSON.parse(eventParams || '""');
      let currentIndex = index;
      if (router === 'myPresale') {
        this.turnToPage('presellOrderList');
        return;
      }
      if (router === 'newsPocketsBalance') {
        this.turnToPage(router);
        return;
      }
      // 开启手机验证
      if (openVerifyPhone && openVerifyPhone !== 'false' &&!this.getUserInfo().phone) {
        // 验证用户信息是否有填写手机号
        this.turnToPage('bindCellphone');
        return;
      }
      if (router == 'myOrder' && goodsType) {
        this.turnToPage(router, {
          goodsType,
          currentIndex
        });
        return;
      }
      if (router == 'vipCard' && globalData.hasFranchiseeList) {
        if (needCollectInfo == 1) {
          this.turnToPage(router, {
            is_member: 1,
            franchisee: globalData.chainAppId || ''
          });
          return;
        }
        this.turnToPage('vipCardList', {
          from: 'userCenterEle',
        });
        return;
      }
      this.turnToPage(router + `?${param}`, {
        from: 'userCenterEle',
      });
    } else {
      // 跳转登录
      this.goLogin({
        success: function () {
          that._userCenterToPage(event);
        }
      });
      return;
    }
  },
  /**
   * 跳转商品详情
   */
  turnToGoodsDetail: function (event) {
    let dataset = event.currentTarget.dataset;
    let id = dataset.id;
    let contact = dataset.contact;
    let goodsType = dataset.goodsType;
    let group = dataset.group;
    let hidestock = dataset.hidestock;
    let isShowVirtualPrice = dataset.isshowvirtualprice;
    let unit = dataset.unit;

    let franchisee = this.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (dataset.appId && dataset.appId !== this.getAppId() && chainParam === '') { // 跳转子店商品
      chainParam += '&franchisee=' + dataset.appId;
    }
    if (group && group == 1) {
      this.turnToPage('gpgoodsDetail?goods_id=' + id + '&activity_id=' + dataset.groupid + '&contact=' + contact + chainParam);
      return;
    }
    switch (+goodsType) {
      case 0:
        this.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + '&isShowVirtualPrice=' + isShowVirtualPrice + chainParam);
        break;
      case 1:
        this.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        break;
      case 3:
        this.turnToPage('toStoreDetail?detail=' + id + chainParam);
        break;
      case 10:
        if (unit) {
          this.turnToPage('hotel?contact=' + contact + '&hidestock=' + hidestock + chainParam);
        } else {
          this.turnToPage('newAppointmentDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        }
        break;
    }
  },
  /*
  * 子店跳转到子店首页
  */
  goToFranchisee: function (mode, param = {}, is_redirect = false) {
    let router = '';
    if (mode == 1) {
      router = 'franchiseeWaimai';
    } else if (mode == 3) {
      router = 'franchiseeTostore';
    } else if (mode == 2) {
      router = 'franchiseeDetail4';
    } else {
      router = 'franchiseeDetail';
    }
    this.turnToPage(router, param, is_redirect);
  },
  /**
   * 分类组件：动态列表、动态分类刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortListVessel: function (componentParams) {
    let that = this;
    let pageInstance = this.getAppCurrentPage();
    let compindex = componentParams['compindex'];
    let newdata = {};
    let needColumnArr = pageInstance.data.eles[compindex].need_column_arr || [];
    let listField = pageInstance.data.eles[compindex].listField;

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].list_data'] = [];
    pageInstance.setData(newdata);

    if (needColumnArr.length) {
      componentParams.param.need_column_arr = needColumnArr;
    }
    if (componentParams.param.form == "app_shop" && (listField.indexOf('distance') > -1 || componentParams.param.sort_key == "distance")){
      let locationInfo = that.globalData.locationInfo;
      if (locationInfo.latitude){
        componentParams.param.extra_cond_arr = {};
        componentParams.param.extra_cond_arr.latitude = locationInfo.latitude;
        componentParams.param.extra_cond_arr.longitude = locationInfo.longitude;
      } else if (componentParams.param.sort_key == "distance"){
        that.getLatLng({
          success: function (latlng) {
            componentParams.param.extra_cond_arr = {};
            componentParams.param.extra_cond_arr.latitude = latlng.latitude;
            componentParams.param.extra_cond_arr.longitude = latlng.longitude;
            that._sortListVessel(componentParams);
          },
          fail: function () {
            that.showToast({
              title: '定位失败，店铺距离将获取不到',
              icon: 'none'
            });
            componentParams.param.sort_key = "";
            that._sortListVessel(componentParams);
          }
        })
        return;
      }
    }

    this.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      data: componentParams.param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let newdata = {};

        for (let j in res.data) {
          for (let k in res.data[j].form_data) {
            if (k == 'category') continue;

            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[j].form_data.virtual_price = that.formVirtualPrice(res.data[j].form_data);
            }
            if (k == 'distance') {
              res.data[j].form_data[k] = util.formatDistance(res.data[j].form_data[k]);
            }
            let description = res.data[j].form_data[k];
            if (listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) { //没有绑定的字段的富文本置为空
              res.data[j].form_data[k] = '';
            }
          }
        }

        newdata['eles[' + compindex + '].list_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        if (pageInstance.data.eles[compindex].type === 'dynamic-classify') {
          newdata['eles[' + compindex + '].sort_key'] = componentParams.param.sort_key || '';
          newdata['eles[' + compindex + '].sort_direction'] = componentParams.param.sort_direction;
        }

        pageInstance.setData(newdata);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 分类组件：商品列表刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortGoodsList: function (componentParams) {
    let that = this;
    let pageInstance = this.getAppCurrentPage();
    let compindex = componentParams['compindex'];
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];

    // 排序组件请求page_size
    componentParams.param.page_size = compData.customFeature.loadingNum || 10;

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].goods_data'] = [];
    newdata['eles[' + compindex + '].param.sort_key'] = componentParams.param.sort_key; //临时处理，后续做了联动之后删除
    newdata['eles[' + compindex + '].param.sort_direction'] = componentParams.param.sort_direction; //临时处理，后续做了联动之后删除
    pageInstance.setData(newdata);

    if (compData.customFeature.form == 'new_appointment' && !compData.customFeature.tpl_id) {
      let noAppointTpl = {};
      noAppointTpl['eles[' + compindex + '].is_more'] = 0;
      noAppointTpl['eles[' + compindex + '].loadingFail'] = false;
      noAppointTpl['eles[' + compindex + '].loading'] = false;
      pageInstance.setData(noAppointTpl);
      return
    }

    this.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      data: componentParams.param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        if (res.status == 0) {
          let appId = that.getAppId();
          let goodslist = res.data;
          goodslist.map((item) => {
            item.form_data.goods_model && delete item.form_data.goods_model;
            if (+componentParams.param.is_app_shop_cate_goods === 1 && item.form_data.app_id !== appId) {
              item.form_data.isSubShopGoods = true;
            } else {
              item.form_data.isSubShopGoods = false;
            }
            item.form_data.discount = (item.form_data.price * 10 / item.form_data.virtual_price).toFixed(2);
            let vip_discount = (item.form_data.vip_min_price * 10 / item.form_data.virtual_price).toFixed(2);
            item.form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
            delete item.form_data.description;
            if (item.form_data.app_shop_data && item.form_data.app_shop_data.distance != undefined) {
              let distance = item.form_data.app_shop_data.distance;
              item.form_data.app_shop_data.distance = util.formatDistance(distance);
            }
          });

          newdata['eles[' + compindex + '].goods_data'] = goodslist;
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 分类组件：多商家刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortFranchiseeList: function (componentParams) {
    let that = this;
    let pageInstance = this.getAppCurrentPage();
    let compindex = componentParams['compindex'];
    let newdata = {};
    let compData = pageInstance.data.eles[compindex];

    componentParams.param.latitude = compData.param.latitude;
    componentParams.param.longitude = compData.param.longitude;

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].franchisee_data'] = [];
    newdata['eles[' + compindex + '].param'] = componentParams.param;
    pageInstance.setData(newdata);
    if (componentParams.param.sort_key == 'distance' && !componentParams.param.latitude) {
      that.showModal({
        content: "未获取到定位！"
      })
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: componentParams.param,
      method: 'post',
      success: function (res) {
        if (res.status == 0) {
          let newdata = {};

          for (let index in res.data) {
            let distance = res.data[index].distance;
            res.data[index].distance = util.formatDistance(distance);
          }
          that._getMyAppShopList(compindex, pageInstance);

          newdata['eles[' + compindex + '].franchisee_data'] = res.data;
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.setData(newdata);
        }
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 获取商家列表（内部函数）
   * @param {*} compindex
   * @param {*} pageInstance
   */
  _getMyAppShopList: function (compindex, pageInstance) {
    let that = this;
    that.sendRequest({
      url: '/index.php?r=AppShop/GetMyAppShopList',
      data: {
        parent_app_id: that.getAppId()
      },
      hideLoading: true,
      success: function (res) {
        let newdata = {};
        let oldList = pageInstance.data.eles[compindex].franchisee_data || [];
        let list = res.data;
        let listId = [];
        if (reset) {
          let l = 0;
          for (let i = 0; i < oldList.length; i++) {
            if (oldList[i].is_audit == 2) {
              l++;
            } else {
              break;
            }
          }
          oldList.splice(0, l);
        }
        for (let i = 0; i < list.length; i++) {
          if (list[i].is_audit == 2) {
            oldList.unshift(list[i]);
            listId.push(list[i].id);
          }
        }
        if (reset) {
          for (let i = 0; i < oldList.length; i++) {
            if (oldList[i].is_audit == 1 && listId.indexOf(oldList[i].id) > -1) {
              oldList.splice(i, 1);
            }
          }
        }
        newdata['eles[' + compindex + '.franchisee_data'] = oldList;

        pageInstance.setData(newdata)
      }
    });
  },
  /**
   * 分类组件：视频列表刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortVideoList: function (componentParams) {
    let that = this;
    let pageInstance = this.getAppCurrentPage();
    let compindex = componentParams['compindex'];

    let newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].video_data'] = [];
    newdata['eles[' + compindex + '].param'] = componentParams.param;
    pageInstance.setData(newdata);

    this.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoList',
      data: componentParams.param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function (res) {
        let rdata = res.data;
        let newdata = {};

        for (let i = 0; i < rdata.length; i++) {
          rdata[i].video_view = that.handlingNumber(rdata[i].video_view);
        }

        newdata['eles[' + compindex + '].video_data'] = rdata;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 点击事件拨打电话
   */
  callPhone: function (event) {
    let phone = event.currentTarget.dataset.phone;
    this.makePhoneCall(phone);
  },
  /**
   * 获取国家列表
   * @param compindex
   */
  getNationList: function (compindex) {
    let pageInstance = this.getAppCurrentPage();
    let newdata = {};
    this.sendRequest({
      url: '/index.php?r=Region/getNationList',
      data: {
        page: 1,
        page_size: 10
      },
      success: function (res) {
        newdata['eles[' + compindex + '].nationList'] = res.data.reverse();
        pageInstance.setData(newdata);
      }
    })
  },
  /**
   * 处理触发刷新列表事件
   * @param {*} event
   * @param {*} params
   */
  tapRefreshListHandler: function (event, params) {
    let pageInstance = this.getAppCurrentPage();
    let eventParams = params || JSON.parse(event.currentTarget.dataset.eventParams);
    let refreshObject = eventParams.refresh_object;

    let componentIndex = this.findComponentIndexById(refreshObject);
    if (componentIndex > -1) {
      let componentData = pageInstance.data.eles[componentIndex];
      // 组件类型
      let type = componentData.type;
      // 组件参数
      let param = componentData.param || {};
      // 封装传入
      let compids_params = {
        compindex: componentIndex,
        param: param,
      }
      this._refreshPageList(type, eventParams, compids_params, pageInstance);
    }
  },
  _refreshPageList: function (eleType, eventParams, compids_params, pageInstance) {
    let index_value = eventParams.index_value == -1 ? '' : eventParams.index_value;
    let requestData = {
      page: 1,
      form: compids_params.param.form,
      is_integral: compids_params.param.is_integral,
      is_count: compids_params.param.form && compids_params.param.is_count ? 1 : 0,
      idx_arr: {
        idx: eventParams.index_segment,
        idx_value: index_value
      }
    };
    let newdata = {};
    newdata['eles[' + compids_params['compindex'] + '].is_search'] = false;
    pageInstance.setData(newdata);

    compids_params.param.idx_arr = requestData.idx_arr;

    if (eleType === 'goods-list' || eleType === 'list-vessel' || eleType === 'topic-list' || eleType == 'group-buy-list') {
      let customFeature = pageInstance.data.eles[compids_params.compindex].customFeature;
      requestData.page_size = customFeature.loadingNum || 10;
      // 商品列表
      if (eleType === 'goods-list') {
        if (customFeature.isShowGroupBuyGoods) {
          requestData.is_group_buy = 1;
        }
        if (customFeature.controlCheck) {
          requestData.is_integral = 3;
        } else {
          if (customFeature.isIntegral) {
            requestData.is_integral = 1;
          } else {
            requestData.is_integral = 5;
          }
        }
      }

      //行业预约  模板为空兼容
      requestData.tpl_id = compids_params.param.tpl_id;
      if (requestData.form == 'new_appointment' && !requestData.tpl_id) {
        let noAppointTpl = {};
        noAppointTpl['eles[' + compids_params['compindex'] + '].goods_data'] = [];
        noAppointTpl['eles[' + compids_params['compindex'] + '].is_more'] = 0;
        pageInstance.setData(noAppointTpl)
        return
      }
    }

    switch (eleType) {
      case 'goods-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshGoodsList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'list-vessel':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshListVessel',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'franchisee-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshFranchiseeList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'topic-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshTopicList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'news-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshNewsList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'video-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshVideoList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'group-buy-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshGroupBuyList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
    }
  },
  //判断是否开启了社区团购
  _isOpenCommunityGroup: function (callback) {
    let that = this;
    this.sendRequest({
      url: '/index.php?r=AppDistribution/getDistributionInfo',
      success: function (res) {
        if (res.data && res.data.app_id) {
          that.globalData.getDistributionInfo = res.data;
          if (typeof callback == "function") {
            callback(res.data);
            return;
          }
          that._isOpenCommunityGroupCenter(true);
        } else {
          that.showModal({
            content: '暂未开启推广'
          })
        }
      }
    })
  },
  //判断是否是团长
  _isOpenCommunityGroupCenter: function (clickPage) {
    let that = this;
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistribution/getDistributorInfo',
      success: function (res) {
        if (clickPage) {
          let threshold_type = +that.globalData.getDistributionInfo.threshold_type; //团长门槛
          let is_block_up = res.data ? (res.data.dis_group_info ? +res.data.dis_group_info.is_block_up : '') : ''; //1停用团长
          let isAudit = res.data ? (res.data.dis_group_info ?  res.data.dis_group_info.is_audit : '') : ''; // 1：审核通过 2：待审核 3：审核拒绝
          that.globalData.getDistributorInfo = res.data;
          if(+isAudit === 1 || +is_block_up === 1 ) { //当是团长或者团长被停用
            that.turnToPage('/communityGroup/pages/communityGroupUserCenter/communityGroupUserCenter'); //团长个人中心
          } else {
            if(+isAudit === 2 || +isAudit === 3) { //当申请中或者申请被拒绝
              that.turnToPage('/communityGroup/pages/communityGroupApplyStatus/communityGroupApplyStatus'); //申请状态显示
            } else { //当没有申请即不是团长
              if(threshold_type != 1 ) { //有门槛
                that.turnToPage('/communityGroup/pages/communityGroupDoor/communityGroupDoor'); //团长门槛页
              } else {
                if (+that.globalData.getDistributionInfo['role_setting'][6]['pop_up_type'] === 0 && that.globalData.getDistributionInfo.role_setting[6].illustration) { //页面招募
                  that.turnToPage('/communityGroup/pages/communityRecruit/communityRecruit'); //招募说明
                } else { //弹窗式
                  that.turnToPage('/communityGroup/pages/communityGroupApply/communityGroupApply'); //申请团长页面
                }
              }
            }
          }
        } else {
          if (res.data) {
            that.globalData.p_id = res.data.id;
            that.globalData.PromotionUserToken = res.data.user_token;
          }
        }
      }
    })
  },
  _isOpenPromotion: function (callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  _isPromotionPerson: function (clickPage) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  _hasSelfCard: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 展示电商商品列表的商品添加购物车弹窗
   */
  showGoodsShoppingcart: function (event) {
    let pageInstance = this.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let goodsId = dataset.id;
    let buynow = dataset.buynow;
    let showVirtualPrice = dataset.isshowvirtualprice || '';
    let newData = {
      goodsId: goodsId,
      showBuynow: buynow,
      showVirtualPrice: showVirtualPrice,
      franchisee: pageInstance.franchiseeId || this.getChainId()
    }
    if (dataset.appId && dataset.appId !== this.getAppId()) {
      newData['franchisee'] = dataset.appId;
    }
    appInstance.goodsShoppingCartRef.current.showDialog(newData);
  },
  /**
   * 展示到店商品列表的商品添加购物车弹窗
   */
  showAddShoppingcart: function (event) {
    let pageInstance = this.getAppCurrentPage();
    let dataset = event.currentTarget.dataset;
    let goodsId = dataset.id;
    let newData = {
      goodsId: goodsId,
      franchisee: pageInstance.franchiseeId || this.getChainId()
    }
    if (dataset.appId && dataset.appId !== this.getAppId()) {
      newData['franchisee'] = dataset.appId;
    }
    appInstance.tostoreShoppingCartRef.current.show(newData);
  },
  /**
   * 获取到店的购物车列表
   */
  getTostoreCartList: function () {
    let pageInstance = this.getAppCurrentPage();
    let franchiseeId = pageInstance.franchiseeId || this.getChainId();
    this.sendRequest({
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: 1,
        page_size: 100,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? this.getAppId() : ''
      },
      success: function (res) {
        let price = 0,
          num = 0,
          addToShoppingCartCount = 0,
          tostoreTypeFlag = false;

        for (let i = res.data.length - 1; i >= 0; i--) {
          let data = res.data[i];
          if (data.goods_type == 3) {
            tostoreTypeFlag = true;
            price += +data.num * +data.price;
            num += +data.num;
          }
          if (pageInstance.goodsId == data.goods_id) {
            addToShoppingCartCount = data.num;
            pageInstance.cart_id = data.id;
          }
        }
        pageInstance.setData({
          tostoreTypeFlag: tostoreTypeFlag,
          cartGoodsNum: num,
          cartGoodsTotalPrice: price.toFixed(2),
          addToShoppingCartCount: addToShoppingCartCount,

        });
      }
    })
  },
  /**
   * 跳转到搜索页面(TODO)
   */
  turnToSearchPage: function (event) {
    let pageInstance = this.getAppCurrentPage();
    let listid = event.target.dataset.listid;
    let param = '';
    if (listid) {
      let integral = '';
      let goodsListIndex = this.findComponentIndexById(listid, pageInstance)
      let customFeature = pageInstance.data.eles[goodsListIndex].customFeature;
      if (customFeature.controlCheck) {
        integral = 3
      } else {
        if (customFeature.isIntegral) {
          integral = 1
        } else {
          integral = 5
        }
      }
      param = '&isHideStock=' + customFeature.isHideStock + '&isHideSales=' + customFeature.isHideSales + '&isShowVirtualPrice=' + customFeature.isShowVirtualPrice + '&isShoppingCart=' + customFeature.isShoppingCart + '&isBuyNow=' + customFeature.isBuyNow;
      if (customFeature.source && customFeature.source !== 'none') {
        param += '&category=' + customFeature.source;
      }
      if (integral) {
        param += '&integral=' + integral;
      }
      if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) { // 是否显示子店商品(排除子店功能页)
        param += '&isShowFG=' + 1;
      }
    }
    if (event.target.dataset.param) {
      this.turnToPage('advance-search?param=' + event.target.dataset.param + param);
    } else {
      this.turnToPage('advance-search?form=' + event.target.dataset.form + param);
    }
  },
  /**
   * 获取节点的信息
   * @param selector
   * @param callback
   */
  getBoundingClientRect: function (selector, callback) {
    let dows = document.querySelectorAll(selector);
    let rects = [];
    dows.forEach(element => {
      rects.push({
        id: element.id,
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight,
        width: element.offsetWidth,
        height: element.offsetHeight
      })
    });
    typeof callback === 'function' && callback(rects);
  },
  /*
  * 秒杀开始之前
  */
  beforeSeckillDownCount: function (formData, page, path) {
    let _this = this,
      downcount;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_start_time,
      showDays: true,
      callback: function () {
        let newData = {};
        newData[path + '.seckill_start_state'] = 1;
        newData[path + '.server_time'] = formData.seckill_start_time;
        page.setData(newData);
        formData.server_time = formData.seckill_start_time;
        _this.duringSeckillDownCount(formData, page, path);
      }
    }, page, path + '.downCount');

    return downcount;
  },
  /*
  * 秒杀正在进行
  */
  duringSeckillDownCount: function (formData, page, path) {
    let _this = this,
      downcount;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_end_time,
      showDays: true,
      callback: function () {
        let newData = {};
        newData[path + '.seckill_start_state'] = 2;
        page.setData(newData);
      }
    }, page, path + '.downCount');

    return downcount;
  },
  /*
  * 拼团开始之前
  */
  beforeGroupDownCount: function (formData, page, path) {
    let _this = this,
      downcount;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_start_time,
      showDays: true,
      callback: function () {
        let newData = {};
        newData[path + '.status'] = 3;
        newData[path + '.current_status'] = 3;
        newData[path + '.server_time'] = formData.seckill_start_time;
        page.setData(newData);
        formData.server_time = formData.seckill_start_time;
        _this.duringGroupDownCount(formData, page, path);
        let dc = '';
        let compid = path.split('.')[0];
      }
    }, page, path + '.downCount');

    return downcount;
  },
  /*
  * 拼团正在进行
  */
  duringGroupDownCount: function (formData, page, path) {
    let _this = this,
      downcount;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_end_time,
      showDays: true,
      callback: function () {
        let newData = {};
        newData[path + '.status'] = 4;
        newData[path + '.current_status'] = 4;
        page.setData(newData);
        if (path == "myTeams") {
          page.loadMyTeams();
        }
      }
    }, page, path + '.downCount');

    return downcount;
  },
  // 需要倒计时的对象
  seckillFunc: {},
  // 倒计时的定时器编号
  seckillInterval: '',
  /**
   * 倒计时
   */
  seckillDownCount: function (opts, page, path) {
    let that = this;
    let opt = {
      startTime: opts.startTime || null,
      endTime: opts.endTime || null,
      callback: opts.callback,
      showDays: opts.showDays || false
    };
    let isiphone = this.isIos();

    if (isiphone && /\-/g.test(opt.endTime)) {
      opt.endTime = opt.endTime.replace(/\-/g, '/');
    }
    if (isiphone && /\-/g.test(opt.startTime)) {
      opt.startTime = opt.startTime.replace(/\-/g, '/');
    }
    if (/^\d+$/.test(opt.endTime)) {
      opt.endTime = opt.endTime * 1000;
    }
    if (/^\d+$/.test(opt.startTime)) {
      opt.startTime = opt.startTime * 1000;
    }

    let target_date = new Date(opt.endTime);
    let current_date = new Date(opt.startTime);
    let difference = target_date - current_date;
    let data = {};
    let len = 'sk' + parseInt(Math.random() * 100000000);
    data = {
      opts: opts,
      page: page,
      path: path,
      difference: difference,
      index: len
    }
    that.seckillFunc[len] = data;

    if (!that.seckillInterval) {
      that.seckillInterval = setInterval(function () {
        let newdata = {};
        let func = that.seckillFunc;
        for (let i in func) {
          let f = func[i];
          let difference = f.difference;
          let _path = f.path;
          let _page = f.page;
          let router = _page.id; // TODO 每个页面的ID

          if (!newdata[router]) {
            newdata[router] = {
              page: _page,
              data: {}
            }
          }
          if (difference < 0) {
            let callback = func[i].opts.callback;
            if (callback && typeof callback === 'function') { callback(); };
            delete that.seckillFunc[i];
            continue;
          }
          let time = that.seckillCountTime(difference, f.opts);
          newdata[router].data[_path + '.hours'] = time[0];
          newdata[router].data[_path + '.minutes'] = time[1];
          newdata[router].data[_path + '.seconds'] = time[2];
          if (f.opts.showDays) {
            newdata[router].data[_path + '.days'] = time[3];
          }

          that.seckillFunc[i].difference -= 1000;
        }
        for (let j in newdata) {

          newdata[j].page.setData(newdata[j].data);
        }
      }, 1000);
    }

    return {
      isClear: false,
      clear: function () {
        if (this.isClear) {
          return;
        }
        this.isClear = true;
        delete that.seckillFunc[len];
        if (util.isPlainObject(that.seckillFunc)) {
          clearInterval(that.seckillInterval);
          that.seckillInterval = '';
        }
      }
    };
  },
  /**
   * 计算倒计时
   */
  seckillCountTime: function (difference, opts) {
    if (difference < 0) {
      return ['00', '00', '00'];
    }

    let _second = 1000,
      _minute = _second * 60,
      _hour = _minute * 60,
      _day = _hour * 24,
      time = [];

    let days = '';
    let hours = Math.floor(difference / _hour);
    let minutes = Math.floor((difference % _hour) / _minute);
    let seconds = Math.floor((difference % _minute) / _second);
    if (opts.showDays) {
      days = Math.floor(difference / _day);
      hours = Math.floor((difference % _day) / _hour);
    }

    hours = (String(hours).length >= 2) ? hours : '0' + hours;
    minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes;
    seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds;

    time[0] = hours;
    time[1] = minutes;
    time[2] = seconds;
    opts.showDays && (time[3] = days);

    return time;
  },
  getAssessList: function (param) {
    param.url = '/index.php?r=AppShop/GetAssessList';
    this.sendRequest(param);
  },
  getOrderDetail: function (param) {
    param.url = '/index.php?r=AppShop/getOrder';
    this.sendRequest(param);
  },
  showUpdateTip: function () {
    // TODO: 可以删除
  },
  // 文字组件跳到地图(文本组件：详情页绑定地图字段对应点击事件)
  textToMap: function (event) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 跳转到视频详情
   * @param {*} event
   */
  turnToVideoDetail: function (event) {
    let id = event.currentTarget.dataset.id;
    let franchisee = this.getPageFranchiseeId();
    let chainParam = franchisee ? '&franchisee=' + franchisee : '';
    this.turnToPage('videoDetail?detail=' + id + chainParam);
  },
  /**
   * 处理数字
   */
  handlingNumber: function (num) {
    num = +num;
    if (num > 1000000) { //大于百万直接用万表示
      return Math.floor(num / 10000) + '万';
    } else if (num > 10000) { //大于一万小于百万的保留一位小数
      return (num / 10000).toString().replace(/([0-9]+.[0-9]{1})[0-9]*/, "$1") + '万';
    } else {
      return num;
    }
  },
  /**
   * 判断是否需要富文本解析 （TODO，没有真的用处）
   * @param {*} data 
   */
  needParseRichText: function (data) {
    return false;
  },
  /**
   * 根据经纬度算出距离
   */
  calculationDistanceByLatLng: function (lat1, lng1, lat2, lng2) {
    const EARTH_RADIUS = 6378137.0;
    const PI = Math.PI;
    let a = (lat1 - lat2) * PI / 180.0;
    let b = (lng1 - lng2) * PI / 180.0;
    let s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(lat1 * PI / 180.0) * Math.cos(lat2 * PI / 180.0) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000.0;
    return s;
  },
  /**
   * 判断是否需要登录
   */
  isNeedRewardModal: function () {
    let that = this;
    that.sendRequest({
      hideLoading: true,
      url: '/index.php?r=appShop/isNeedLogin',
      data: {},
      success: function (res) {
        if (res.status == 0 && res.data == 1 && !that.isLogin()) {
          that.goLogin({});
        }
      }
    });
  },
  loginForRewardPoint: function (addTime) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  getCollectActivity: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  recvCollectRewards: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  getEffectActivity: function (psid) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  getRecvChance: function (type, s_token, isLogin) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  recvRewards: function (immediately) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  // 积分弹窗回调
  rewardPointCB: function (cbTy) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  animationEnd: function (e) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取店铺设置
   */
  getAppECStoreConfig: function (callback, franchiseeId) {
    let _this = this;
    if (this.globalData.goodsStoreConfig && !franchiseeId) {
      callback(this.globalData.goodsStoreConfig);
      return;
    }

    if (franchiseeId && this.globalData.goodsfranchiseeStoreConfig[franchiseeId]) {
      callback(this.globalData.goodsfranchiseeStoreConfig[franchiseeId]);
      return;
    }
    franchiseeId = franchiseeId || this.getPageFranchiseeId();
    this.sendRequest({
      url: '/index.php?r=AppEcommerce/getAppBECStoreConfig',
      data: {
        sub_shop_app_id: franchiseeId || ''
      },
      success: function (res) {
        if (franchiseeId) {
          _this.globalData.goodsfranchiseeStoreConfig[franchiseeId] = res.data;
        } else {
          _this.globalData.goodsStoreConfig = res.data;
        }
        callback && callback(res.data)
      }
    })
  },
  // 日志
  addLog: function () {
    // TODO: web端后续需要日志在处理
  },
  addDebug: function () {
    // TODO: web端后续需要日志在处理
  },
  addInfo: function () {
    // TODO: web端后续需要日志在处理
  },
  addWarn: function () {
    // TODO: web端后续需要日志在处理
  },
  addError: function () {
    // TODO: web端后续需要日志在处理
  },
  saveLog: function (tp, argu) {
    // TODO: web端后续需要日志在处理
  },
  sendLog: function () {
    // TODO: web端后续需要日志在处理
  },
  getChainStoreInfo: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 判断是否在营业时间内
   */
  businessTimeCompare: function (time) {
    let now = new Date();
    let min = now.getMinutes().toString();
    if (min.length <= 1) {
      min = '0' + min;
    }
    let current = +(now.getHours().toString() + min);
    let business = false;
    for (let i = 0; i < time.length; i++) {
      if (current > +time[i].start_time_str && current < +time[i].end_time_str) {
        business = true;
      }
    }
    return business;
  },
  /**
   * 清除连锁店信息
   */
  clearChainInfo: function () {
    this.globalData.chainAppId = '';
    this.globalData.chainHistoryDataId = '';
    this.globalData.indexPageRefresh = true;
    this.globalData.p_u = '';
    // wx.removeStorageSync('chainStore'); // 这个句后续要改动一下
  },
  /**
   * 获取子店ID
   */
  getPageFranchiseeId: function () {
    let pageInstance = this.getAppCurrentPage() || {};
    return pageInstance.franchiseeId || this.getChainId() || '';
  },
  setCommunityGroupRefresh() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  setNowGommunityToken(token) {
    this.setStorage({
      key: 'nowGommunityToken',
      data: token
    });
  },
  getNowGommunityToken() {
    return this.getStorageSync('nowGommunityToken');
  },
  getCommunityActiveMessage() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  pageRoot: {
    // TODO: 可以删除
  },
  /**
   * 记录子店访问量
   */
  addSubShopView: function (sub_app_id) {
    this.sendRequest({
      url: '/index.php?r=AppShopManage/AddSubShopView',
      data: {
        sub_app_id: sub_app_id,
      },
      success: function (res) {},
      fail: function () {}
    });
  },
  getPromotionPersonId: function (callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 判断是否需要底部技术支持
   */
  checkTechSupport: function (pageInstance) {
    let that = this;
    pageInstance = pageInstance || this.getAppCurrentPage();
    if(that.globalData.techSupport){
      pageInstance.setData({
        techSupport: that.globalData.techSupport
      });
      return;
    }
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppData/CheckTechSupport',
      success: function (res) {
        that.globalData.techSupport = res.data;
        pageInstance.setData({
          techSupport: res.data
        });
      }
    })
  },
  /**
   * 检查小程序是单店、总店还是子店
   */
  checkIsSubOrParentShop: function() {
    let that = this;
    if (this.globalData.shopTypeData) {
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppShopManage/CheckIsAppSubOrParentShop',
      success: function(res) {
        if (res.data) {
          // 保存在全局
          that.setShopTypeData(res.data);
        }
      }
    });
  },
  /**
   *  全局参数get、set部分 start
   *
   */
  /**
   * 获取首页router
   */
  getHomepageRouter: function () {
    return this.globalData.homepageRouter;
  },
  /**
   * 设置APPID
   */
  setAppId: function (value) {
    setAppId(value); // 设置sessionStorage里的APPID
    this.globalData.appId = value;
  },
  /**
   * 获取APPID
   */
  getAppId: function () {
    return this.globalData.appId || getAppId();
  },
  /**
   * 如果有连锁店ID，返回连锁店ID。否则返回总店APPID
   */
  getChainAppId: function () {
    return this.globalData.chainAppId || this.globalData.appId;
  },
  /**
   * 获取连锁店ID
   */
  getChainId: function () {
    return this.globalData.chainAppId || '';
  },
  /**
   * 获取当前页面的路由
   */
  getPageRouter: function () {
    let pageInstance = this.getAppCurrentPage();
    if (pageInstance) {
      return pageInstance.data.router;
    }
    return this.globalData.pageRouter;
  },
  /**
   * 设置页面pageRouter
   * @param url
   */
  setPageRouter: function (url) {
    let urlMatch = url.match(/.*\/(\w+)\??$/);
    if (urlMatch) {
      this.globalData.pageRouter = urlMatch[1];
    }
  },
  /**
   * 获取最后一个页面的路由
   */
  getLastPageRouter: function () {
    let lastPage = this.getAppCurrentPage();
    if (pageInstance) {
      return pageInstance.data.router;
    }
    return this.globalData.pageRouter;
  },
  /**
   * 获取默认的图片路径
   */
  getDefaultPhoto: function () {
    return this.globalData.defaultPhoto;
  },
  getSessionKey: function () {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  setSessionKey: function (session_key) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取用户信息
   */
  getUserInfo: function(key) {
    return key ? this.globalData.userInfo[key] : this.globalData.userInfo;
  },
  /**
   * 保存用户信息
   * @param {*} info
   */
  setUserInfoStorage: function(info) {
    for (let key in info) {
      this.globalData.userInfo[key] = info[key];
    }
    this.setStorage({
      key: 'userInfo',
      data: this.globalData.userInfo
    })
  },
  /**
   * 设置页面的用户信息
   */
  setPageUserInfo: function(options) {
    let currentPage = this.getAppCurrentPage();
    // 若不为自定义页面
    if (!currentPage) {
      return;
    }
    let newdata = {};
    newdata['userInfo'] = this.getUserInfo();
    currentPage.setData(newdata);
  },
  /**
   * 获取当前页面实例
   */
  getAppCurrentPage: function (options) {
    return pageInstance;
  },
  /**
   * 获取底部导航的路径
   */
  getTabPagePathArr: function () {
    return this.globalData.tabBarPagePathArr;
  },
  /**
   * 获取APP的标题
   */
  getAppTitle: function () {
    return this.globalData.appTitle;
  },
  /**
   * 小程序使用（TODO，后续可以删掉，保留防止报错）
   */
  getWxParseResult: function (data) {
    return data;
  },
  /**
   * 获取APP的描述
   */
  getAppDescription: function () {
    return this.globalData.appDescription;
  },
  /**
   * 把定位信息存下来
   */
  setLocationInfo: function (info) {
    this.globalData.locationInfo = info;
  },
  /**
   * 获取定位信息
   */
  getLocationInfo: function () {
    return this.globalData.locationInfo;
  },
  /**
   * 获取请求的域名
   */
  getSiteBaseUrl: function () {
    return this.globalData.siteBaseUrl;
  },
  /**
   * 获取cdn域名
   */
  getCdnUrl: function () {
    return this.globalData.cdnUrl;
  },
  /**
   * TODO 暂时不清楚作用
   */
  getUrlLocationId: function () {
    return this.globalData.urlLocationId;
  },
  getPreviewGoodsInfo: function () {
    return this.globalData.previewGoodsOrderGoodsInfo;
  },
  setPreviewGoodsInfo: function (goodsInfoArr) {
    this.globalData.previewGoodsOrderGoodsInfo = goodsInfoArr;
  },
  getGoodsAdditionalInfo: function () {
    return this.globalData.goodsAdditionalInfo;
  },
  setGoodsAdditionalInfo: function (additionalInfo) {
    this.globalData.goodsAdditionalInfo = additionalInfo;
  },
  /**
   * 二维码标记
   * TODO(位置要移动)
   */
  showQRRemark: function(e) {
    let data = {}
    let compindex = e.currentTarget.dataset.compindex;
    let isShow = e.currentTarget.dataset.isshow;
    let pageInstance = this.getAppCurrentPage();
    if (isShow == 'true') {
      data['eles[' + compindex + '].userData.qrRemarkShow'] = true;
      pageInstance.setData(data);
      let url2 = '/index.php?r=appVipCard/getVipQRCode';
      let id = e.currentTarget.dataset.id;
      let is_paid_vip = e.currentTarget.dataset.type;
      this.sendRequest({
        url: url2,
        data: {
          id: id,
          is_paid_vip: is_paid_vip
        },
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success: function (res) {
          let qrData = {};
          qrData['eles[' + compindex + '].qrData'] = res.data;
          pageInstance.setData(qrData);
        }
      })
    } else {
      data['eles[' + compindex + '].userData.qrRemarkShow'] = false;
      pageInstance.setData(data);
    }
  },
  /**
   * 获取是否登录
   */
  getIsLogin: function () {
    let appId = this.getAppId();
    return docCookies.getItem(appId + '_webappLogin') == 1;
  },
  /**
   * 设置是否登录
   * @param {boolean} isLogin
   */
  setIsLogin: function (isLogin) {
    let appId = this.getAppId();
    if (isLogin) {
      let exdate = new Date();
      exdate.setMinutes(exdate.getMinutes() + 120);
      docCookies.setItem('webappLogin', '1', exdate);
      docCookies.setItem(appId + '_webappLogin', '1', exdate);
      this.globalData.isLogin = true;
    } else {
      docCookies.setItem('webappLogin', '0');
      docCookies.setItem(appId + '_webappLogin', '0');
      this.globalData.isLogin = false;
    }
    this.removeStorage('nowSessionData'); // 重新登录或退出登录时清除本地对话缓存
  },
  getSystemInfoData: function () {
    let res = {};
    if (this.globalData.systemInfo) {
      return this.globalData.systemInfo;
    }
    try {
      if (this.isWeixin()) {
        res = this.getSystemInfoSync();
        res.rpxRatio = 750 / res.windowWidth;
      } else {
        res.rpxRatio = 750 / window.screen.width;
      }
      this.setSystemInfoData(res);
    } catch (e) {
      this.showModal({
        content: '获取系统信息失败'
      })
    }
    return res || {};
  },
  setSystemInfoData: function (res) {
    res.rpxRatio = 750 / res.windowWidth;
    this.globalData.systemInfo = res;
  },
  setShopTypeData: function(shopData) {
    this.globalData.shopTypeData = shopData;
  },
  getShopTypeData: function() {
    return this.globalData.shopTypeData;
  },
  /**
   * 判断当前页是否有设置底部导航
   */
  isTabBarPage: function () {
    let pageInstance = this.getAppCurrentPage();
    let hasTabNav = false;
    if (pageInstance) {
      // 存在与底部导航路由数组中
      if (this.globalData.tabBarPagePathArr.indexOf(pageInstance.route) > -1) {
        hasTabNav = true;
      }
    }
    return hasTabNav;
  },
  /**
   * 获取当前页面栈
   */
  getCurrentPages: function () {
    return this.globalData.currentPages;
  },
  /**
   * 获取当前页面在页面栈上的数据
   */
  getCurrentPage: function () {
    let currentPages = this.getCurrentPages();
    return currentPages[currentPages.length - 1];
  },
  /**
   * 游客登录
   */
  autoTouristLogin: function() {
    return new Promise((resolve, reject) => {
      this.sendRequest({
        url: '/index.php?r=AppUser/phoneReg',
        data: {
          phone: '16666666666',
          code: '123456',
        },
        success: () => {
          // 设置登录成功
          this.setIsLogin(true);
          // 请求用户数据存到本地
          this.requestUserInfo();
        },
        complete: () => {
          resolve();
        }
      })
    })
  },
  /**
   * 微信原生方法获取视频组件实例
   */
  createVideoContext: function(id) {
    return document.getElementById(id);
  },
  /*
   * 获取系统信息
   * TODO
   */
  getSystemInfo: function(options = {}){
    let systemInfo = {
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
    if (options.success && typeof options.success === 'function') {
      options.success(systemInfo)
    }
    if (options.complete && typeof options.success === 'function') {
      options.complete(systemInfo)
    }
    return systemInfo;
  },
  /*
   * 同步获取系统信息(与小程序的方法名相同)
   */
  getSystemInfoSync: function(options) {
    return this.getSystemInfo(options);
  },
  /**
   * 判断是否在微信里面
   */
  isWeixin: (function(){
    let isWeixin = false;
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      isWeixin = true;
    }
    return () => isWeixin;
  })(),
  /**
   * 判断是否在抖音里面
   */
   isDouyin: (function(){
    let isDouyin = false;
    if (navigator.userAgent.toLowerCase().match(/aweme/i) == 'aweme') {
      isDouyin = true;
    }
    return () => isDouyin;
  })(),
  /**
   * 判断是否为安卓
   */
  isAndroid: function(){
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('android') > -1 || ua.indexOf('linux') > -1;
  },
  /**
   * 判断是否为ios
   */
  isIos: function(){
    const ua = navigator.userAgent.toLowerCase();
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  /**
   * 判断是否在pc端
   */
  isPC: function(){
    const ua = navigator.userAgent;
    return !(ua.match(/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i));
  }
};

export {
  setApp,
  appInstance,
  appMethod,
  globalData
}



// WEBPACK FOOTER //
// ./src/utils/app.jsx